<template>
  <div>
    <div id="background_wrap">
      <h1 style="opacity: 0">Ez Chicken</h1>
    </div>

    <div id="smartAppContainer">
      <v-app class="app">
        <!--        <DebuggingConsole></DebuggingConsole>-->
        <OfflineLifecycle></OfflineLifecycle>
        <RestoreCartItems></RestoreCartItems>
        <InhouseLifecycle></InhouseLifecycle>
        <InventoryLifecycle></InventoryLifecycle>


        <div class="pwa" id="scrollTop">
          <AppHead @menu="drawer = !drawer"></AppHead>
          <div class="prelative" v-if="$store.state.showSearch">
            <Search></Search>
          </div>

          <!--            <keep-alive>-->
          <router-view/>
          <!--            </keep-alive>-->

          <DialogBg></DialogBg>

          <my-popup
            v-if="$store.getters.showMyPopup"
            @request-close="closeMyPopup"
          >
            <item-additionals v-if="$store.getters.showItemAdditionals"
                              style="width: 100%"
                              ref="wc_item_additionals"
                              @close-additionals="closeItemAdditionals"
                              @click-image="clickArticleImage"
                              @add-to-cart="prepareAddToCart"
            ></item-additionals>
          </my-popup>

          <!--            Only for iframes-->
          <!--            <div class="addedOverlay maxw maxh" v-if="$store.state.showAddedOverlay">-->
          <!--                <div class="aoverlay maxw text-center" :style="{top: $store.state.yA + 'px'}">-->
          <!--                    <div class="myDisplay1">Zum Warenkorb hinzugefügt</div>-->
          <!--                    <v-icon color="primary" x-large>mdi-check</v-icon>-->
          <!--                </div>-->
          <!--            </div>-->

          <!--            Not for iframes-->
          <!--            <added-overlay v-if="$store.state.showAddedOverlay"></added-overlay>-->
          <v-overlay :value="$store.getters.showAddedOverlay" z-index="104">
            <div class="aoverlay text-center">
              <div class="myDisplay1">Zum Warenkorb hinzugefügt</div>
              <v-icon dark x-large>mdi-check</v-icon>
            </div>
          </v-overlay>

          <!--            <div class="mobile">-->
          <!--                -->
          <!--            </div>-->
          <!--            <div class="tablet">-->
          <!--                -->
          <!--            </div>-->


          <!--            <div class="afooter text-center text-md-left"-->
          <!--                 v-show="$route.name !== 'Tischreservierung' && $route.name !== 'Checkin' && $route.name !== 'Aktuelles' && $route.name !== 'Abholung'"-->
          <!--            >-->
          <!--                <div class="a">-->
          <!--                    <v-container dark grid-list-md>-->
          <!--                        <v-layout row wrap>-->
          <!--                            <v-flex xs12 sm12 md3>-->
          <!--                                <div class="d-flex justify-center align-center maxh logo">-->
          <!--                                    <img alt="Kikis Deko- und Aromashop" src="./assets/icons/logo.png"-->
          <!--                                         @click="gotoStart">-->
          <!--                                </div>-->
          <!--                                <div class="spacer-25 mobile"></div>-->
          <!--                            </v-flex>-->
          <!--                            <v-flex xs12 sm6 md3 class="text-center tablet">-->
          <!--                                <div class="d-inline-block text-left">-->
          <!--                                    <h4 @click.passive="gotoProducts" class="pointer">Sortiment</h4>-->
          <!--                                    <div v-for="cat in foodCategories"><a-->
          <!--                                            @click.passive="gotoCategory(cat.categoryDE)">{{cat.categoryDE}}</a>-->
          <!--                                        &lt;!&ndash;                                    :href="'/#/Produkte/'+safe(cat.categoryDE)"&ndash;&gt;-->
          <!--                                    </div>-->
          <!--                                </div>-->
          <!--                                &lt;!&ndash;                                <div v-for="cat in drinkCategories"><a&ndash;&gt;-->
          <!--                                &lt;!&ndash;                                        @click.passive="gotoDrinkCategory(cat.categoryDE)">{{cat.categoryDE}}</a>&ndash;&gt;-->
          <!--                                &lt;!&ndash;                                </div>&ndash;&gt;-->
          <!--                            </v-flex>-->
          <!--                            <v-flex xs4 sm6 md3 class="text-center">-->
          <!--                                <div class="d-inline-block text-left">-->
          <!--                                    <h4>Übersicht</h4>-->
          <!--                                    <div>-->
          <!--                                        <router-link :to="{ name: 'Sortiment' }">Sortiment</router-link>-->
          <!--                                    </div>-->
          <!--                                    <div>-->
          <!--                                        <router-link :to="{ name: 'BeschreibungDerOele' }"><span class="hidden-xs-only">Beschreibung der </span>Öle-->
          <!--                                        </router-link>-->
          <!--                                    </div>-->
          <!--                                    &lt;!&ndash;                                    <div>&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                        <router-link @click.native.passive="jt" :to="{ name: 'Öffnungszeiten' }">&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                            Öffnungszeiten&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                        </router-link>&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                    </div>&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                    <div>&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                        <router-link @click.native.passive="jt" :to="{ name: 'Favoriten' }">Favoriten&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                        </router-link>&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                    </div>&ndash;&gt;-->

          <!--                                    <div>-->
          <!--                                        <router-link @click.native.passive="jt" :to="{ name: 'Lieferkosten' }">-->
          <!--                                            Lieferkosten-->
          <!--                                        </router-link>-->
          <!--                                    </div>-->
          <!--                                    <div>-->
          <!--                                        <router-link @click.native.passive="jt" :to="{ name: 'Impressum' }">Impressum-->
          <!--                                        </router-link>-->
          <!--                                    </div>-->
          <!--                                </div>-->
          <!--                            </v-flex>-->
          <!--                            <v-flex xs8 sm12 md3 class="text-left">-->
          <!--                                <h4>Kontakt</h4>-->

          <!--                                <table class="contactTable">-->
          <!--                                    <tr>-->
          <!--                                        <td>Email:</td>-->
          <!--                                        <td>info@kikis-deko-und-aromashop.de</td>-->
          <!--                                    </tr>-->
          <!--                                    <tr>-->
          <!--                                        <td>Mobil:</td>-->
          <!--                                        <td>0176-48002516</td>-->
          <!--                                    </tr>-->
          <!--                                    <tr>-->
          <!--                                        &lt;!&ndash;                                        <td>Homepage:</td>&ndash;&gt;-->
          <!--                                        <td colspan="2" class="text-no-wrap">-->
          <!--                                            <a href="https://kikis-deko-und-aromashop.de">kikis-deko-und-aromashop.de</a>-->
          <!--                                        </td>-->
          <!--                                    </tr>-->
          <!--                                </table>-->
          <!--                                <div class="pt-4">-->
          <!--                                    <a href="https://qsignal.de/" target="_blank">-->
          <!--                                        <img style="width: initial"-->
          <!--                                             src="https://eu1-qsignal.s3.eu-central-1.amazonaws.com/images/powered_by_qsignal-white.png"-->
          <!--                                             alt="Qsignal App Agentur">-->
          <!--                                    </a>-->
          <!--                                </div>-->
          <!--                            </v-flex>-->
          <!--                        </v-layout>-->


          <!--                    </v-container>-->
          <!--                </div>-->

          <!--                <div class="b">-->
          <!--                    <v-container dark grid-list-xl>-->
          <!--                        <v-layout row wrap class="justify-space-between">-->
          <!--                            <v-flex xs12>-->
          <!--                                <div class="pt-3"></div>-->
          <!--                            </v-flex>-->
          <!--                            &lt;!&ndash;                            <v-flex xs12 md4 class="hIpacity">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                &lt;!&ndash;                                <div class="spacer-25 hidden-md-and-up"></div>&ndash;&gt;&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <div class="spacer-15 hidden-md-and-up"></div>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <div class="hidden-sm-and-down">© 2020 Amalie Genusskult</div>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <div class="hidden-md-and-up" style="margin-bottom: -15px;">© 2020 Amalie Genusskult&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </div>&ndash;&gt;-->

          <!--                            &lt;!&ndash;                            </v-flex>&ndash;&gt;-->
          <!--                            <v-flex xs12 md5 class="hIpacity">-->
          <!--                                <div class="text-center">-->
          <!--                                    <router-link class="d-inline-block mr-4 mb-4" :to="{ name: 'Lieferkosten' }">-->
          <!--                                        Verpackungs- und Versandkosten-->
          <!--                                    </router-link>-->
          <!--                                    <router-link class="d-inline-block mr-4 mb-4" :to="{ name: 'Impressum' }">-->
          <!--                                        Impressum-->
          <!--                                    </router-link>-->
          <!--                                    <router-link class="d-inline-block mr-4 mb-4" :to="{ name: 'Datenschutz' }">-->
          <!--                                        Datenschutzerklärung-->
          <!--                                    </router-link>-->
          <!--                                    <router-link class="d-inline-block mr-4 mb-4" :to="{ name: 'Cookies' }">Cookies-->
          <!--                                    </router-link>-->
          <!--                                    <router-link class="d-inline-block" :to="{ name: 'AGB' }">AGB</router-link>-->
          <!--                                    &lt;!&ndash;                                    <router-link :to="{ name: 'Cookies' }">Cookies</router-link>&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                    <router-link :to="{ name: 'AGB' }">AGB</router-link>&ndash;&gt;-->
          <!--                                </div>-->
          <!--                                &lt;!&ndash;                                <span></span>&ndash;&gt;-->
          <!--                            </v-flex>-->
          <!--                            &lt;!&ndash;                            <v-flex xs12 class="hidden-md-and-up">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <div class="text-center">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <a href="https://baeckerei-theurer.de/"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                       rel="noopener"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                       class="font-weight-bold"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                       style="text-decoration: none; color:white"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                       target="_blank">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                        baeckerei-theurer.de&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    </a>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </div>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-flex>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            <v-flex xs12>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            text-uppercase&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-flex>&ndash;&gt;-->
          <!--                            <v-flex xs12 md3>-->
          <!--                                <v-icon class="pointer" dark large @click.native.passive="openInsta">mdi-instagram-->
          <!--                                </v-icon>-->
          <!--                                <v-icon class="pointer" dark large @click.native.passive="openFacebook">mdi-facebook-->
          <!--                                </v-icon>-->
          <!--                                <div class="spacer-15 hidden-md-and-up"></div>-->
          <!--                                &lt;!&ndash;                                <v-icon dark medium>mdi-instagram</v-icon>&ndash;&gt;-->
          <!--                                &lt;!&ndash;                                <v-icon dark medium>mdi-youtube</v-icon>&ndash;&gt;-->
          <!--                            </v-flex>-->
          <!--                            &lt;!&ndash;                            <v-flex xs12 class="text-center pt-5">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <a href="https://qsignal.de/" target="_blank">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                    <img src="https://eu1-qsignal.s3.eu-central-1.amazonaws.com/images/powered_by_qsignal-white.png"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                         alt="Qsignal Agentur für Apps der neusten Generation">&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                </a>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-flex>&ndash;&gt;-->
          <!--                            <v-flex xs12 class="hidden-sm-and-down">-->
          <!--                                <div class="pb-2 text-center">-->
          <!--                                    &lt;!&ndash;                                    <a href="https://baeckerei-theurer.de/"&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                       rel="noopener"&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                       class="font-weight-bold"&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                       style="text-decoration: none; color:white"&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                       target="_blank">&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                        jetztessen.de&ndash;&gt;-->
          <!--                                    &lt;!&ndash;                                    </a>&ndash;&gt;-->
          <!--                                </div>-->
          <!--                            </v-flex>-->
          <!--                            &lt;!&ndash;                            <v-flex xs12>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                                <div style="font-size: 0.9em">powered by Qsignal IT Services</div>&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            </v-flex>&ndash;&gt;-->
          <!--                        </v-layout>-->
          <!--                    </v-container>-->
          <!--                    <div class="hidden-sm-and-up" style="height: 56px;"></div>-->
          <!--                </div>-->

          <!--            </div>-->


          <!--            <div class="bottomActions maxw" v-if="showBottomActions">-->
          <!--                <v-bottom-navigation-->
          <!--                        class="hidden-sm-and-up" style="justify-content: space-evenly"-->
          <!--                >-->
          <!--                    <v-btn @click.native.passive="goBack">-->
          <!--                        <span>Zurück</span>-->
          <!--                        <v-icon>mdi-arrow-left</v-icon>-->
          <!--                    </v-btn>-->

          <!--                    <v-btn @click.native.passive="gotoStart">-->
          <!--                        <span>Home</span>-->
          <!--                        <v-icon>mdi-home</v-icon>-->
          <!--                    </v-btn>-->

          <!--                    <v-btn @click.native.passive="gotoSortiment">-->
          <!--                        <span>Produkte</span>-->
          <!--                        <v-icon>mdi-spa</v-icon>-->
          <!--                    </v-btn>-->

          <!--                    &lt;!&ndash;                    <v-btn @click.native.passive="gotoCoupons">&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        <span>Coupons</span>&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        <v-icon>mdi-ticket-percent</v-icon>&ndash;&gt;-->
          <!--                    &lt;!&ndash;                    </v-btn>&ndash;&gt;-->

          <!--                    &lt;!&ndash;                    TODO activate for online&ndash;&gt;-->
          <!--                    <v-btn @click.native.passive="gotoCart">-->
          <!--                        <span>Korb</span>-->
          <!--                        <v-badge-->
          <!--                                v-if="itemsCount > 0"-->
          <!--                                color="#0A0A0A"-->
          <!--                                :content="itemsCount"-->
          <!--                                overlap-->
          <!--                        >-->
          <!--                            &lt;!&ndash;                            offset-x="20"&ndash;&gt;-->
          <!--                            &lt;!&ndash;                            offset-y="20"&ndash;&gt;-->
          <!--                            <v-icon medium>mdi-cart</v-icon>-->
          <!--                        </v-badge>-->
          <!--                        <v-icon v-else>mdi-cart</v-icon>-->
          <!--                    </v-btn>-->
          <!--                </v-bottom-navigation>-->
          <!--            </div>-->

        </div>

        <sidebar :drawer="drawer" @closeDrawer="drawer = false"></sidebar>

        <v-dialog content-class="dialogText"
                  activator="#foo" v-model="infoDialog" max-width="600" :light="true">
          <!--            <v-btn slot="activator" dark class="d-none">Open Dialog</v-btn>-->
          <!--            <div class="safeScroll">-->
          <v-card>
            <!--                <div class="safeScroll">-->
            <div class="spacer-15"></div>
            <div class="bigger-input line dialogText">
              <v-card-title class="justify-center">
                <h3 class="text-center dialogText maxw" v-html="currentInfoTitle"></h3>
              </v-card-title>
              <div class="text-center" v-if="currentInfoImage.length > 0">
                <div class="spacer-15"></div>
                <v-img
                  :src="currentInfoImage"
                  contain=""
                  position="center center"
                  height="200"
                />
              </div>
              <!--                    <div class="spacer-15"></div>-->
              <v-card-text class="bigger-line" v-if="currentInfoText.length >0">
                <div class="dialogText" v-html="currentInfoText"></div>
              </v-card-text>
            </div>
            <v-card-actions class="text-center justify-center">
              <v-btn class="okBtn btn-df" rounded large text @click="closeInfoDialog">OK</v-btn>
            </v-card-actions>
            <div class="pb-3"></div>
            <!--                </div>-->
          </v-card>
          <!--            </div>-->
        </v-dialog>

        <DsgvoDialog :dialog="showDsgvoDialog" v-if="!$store.getters.isKiosk"
                     @close="showDsgvoDialog = false"></DsgvoDialog>

        <!--        <referral-hint-dialog :dialog="showReferralProgram" :rp="currentReferralProgram"-->
        <!--                              @close="showReferralProgram = false"></referral-hint-dialog>-->

        <!--        <offer-hint-dialog :dialog="offerHintDialog" @close="offerHintDialog = false"></offer-hint-dialog>-->

        <!--        <offer-info-dialog :offerId="currentOfferId" :dialog="offerInfoDialog"-->
        <!--                           @close="closeOfferInfoDialog"></offer-info-dialog>-->

        <!--        <coupon-info-dialog :coupon="currentCoupon" :dialog="showPromo"-->
        <!--                            @close="closeCouponInfoDialog"></coupon-info-dialog>-->

        <share-dialog :dialog="shareDialog" @close="shareDialog = false"></share-dialog>

        <question-dialog :dialog="questionDialog"
                         :question="currentQuestion"
                         :text="currentQtext"
                         :yes-label="currentQYesLabel"
                         :no-label="currentQNoLabel"
                         :biggerYesButton="biggerYesButton"
                         @close="questionDialog = false; $ebus.$emit('questionClosed')"
                         @silentclose="questionDialog = false"
                         @yes="questionYes"
                         @no="questionNo"
        ></question-dialog>

        <GangDialog :gang1="showG1" :gang2="showG2" :gang3="showG3"
                    :dialog="showGangDialog" @silentclose="showGangDialog = false"
        ></GangDialog>


        <pwa-promo-dialog :dialog="showInstallPromo" @close="showInstallPromo = false"></pwa-promo-dialog>

        <v-overlay :value="$store.state.showLoading" z-index="105">
          <div class="text-center">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
            <div class="myDisplay1">LOADING</div>
          </div>
        </v-overlay>
        <!--        &lt;!&ndash;        <notifications position="top right" style="top:20px; right:20px;width:350px"/>&ndash;&gt;-->


        <div class="text-center">
          <v-bottom-sheet v-model="showSheet">
            <!--                <template v-slot:activator="{ on }">-->
            <!--                    <v-btn-->
            <!--                            color="green"-->
            <!--                            dark-->
            <!--                            v-on="on"-->
            <!--                    >-->
            <!--                        Open Persistent-->
            <!--                    </v-btn>-->
            <!--                </template>-->
            <v-sheet class="d-flex justify-center" height="200px">
              <div class="align-self-center text-center">
                <div class="mt-3 pa-3 black--text"> {{ sheetText }}</div>
                <v-btn
                  class="okBtn btn-df" rounded
                  @click="showSheet = false">
                  OK
                </v-btn>
              </div>

            </v-sheet>
          </v-bottom-sheet>
        </div>


        <v-snackbar
          v-model="showSnackbar"
          :top="true"
          multi-line
          :timeout="snackTime"
        >
          <!--            :timeout="snackTime"-->
          <!--            <span class="mr-2 bigger-input">⚡</span> {{ // snackText }}-->
          <v-layout row class="flex-nowrap maxw">
            <div class="align-self-center">
              <v-icon class="mr-2" color="white" large>mdi-information-variant</v-icon>
            </div>
            <span style="font-size: 1.4em;line-height: 1.4em; margin-top: 3px; flex-grow: 1">{{ snackText }}</span>
            <v-btn icon color="white" class="align-self-center" @click="showSnackbar = false">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-layout>

          <!--            <v-btn-->
          <!--                    @click="showSnackbar = false"-->
          <!--            >-->
          <!--                OK-->
          <!--            </v-btn>-->
        </v-snackbar>

        <!--        <div id="scrollDown"-->
        <!--             :class="{pulsing: scrollPosition < 300}"-->
        <!--             @click.passive="scrollDown"-->
        <!--             v-show="showScrollDown && !$store.state.hideScroll">-->
        <!--            <v-btn icon dark>-->
        <!--                <v-icon dark large>mdi-arrow-down</v-icon>-->
        <!--            </v-btn>-->
        <!--        </div>-->

        <div class="pwa-overly" v-if="showInstallPromo && !$store.getters.inhouse" @click.passive="clickPwaOverlay"></div>

        <!--                <div class="version">{{displayAppVersion}}</div>-->

        <!--        <div class="debugYoffset" :style="{ top: yA+'px'}">{{yA}}px</div>-->

        <!--        <div v-if="$store.state.enableSelfServiceExtras">-->
        <!--            <video loop id="video-element" src="/blank.mp4"></video>-->
        <!--        </div>-->

        <AddDirectlyHandler></AddDirectlyHandler>

        <StempelLogic></StempelLogic>

        <div class="fullImage superCenter" :class="{isMobile:isMobile}"
             v-if="fullImageSrc.length > 0"
             @click.passive.stop="fullImageSrc = ''">
          <img :src="fullImageSrc"
               class="rImg"
               :class="{doFade: fullImageSrc.length > 0}"
               :key="fullImageSrc"
               v-if="fullImageSrc.length > 0"
          >
          <div class="tip pointer">
            <div class="pt-1 pb-1">
              <v-icon big class="myWhite">mdi-close</v-icon>
            </div>
            <h3 style="color: white;">TAP TO CLOSE </h3>
          </div>
        </div>


        <div class="invisible all">{{ showDialogContainer }}</div>
        <v-dialog content-class="dialogText"
                  v-model="_showDialogContainer" persistent
                  fullscreen :scrim="false">

          <IframeOverlay v-show="_showDialogContainer && $store.getters.secondSelectedDialog === 'IframeOverlay'"></IframeOverlay>

          <Agb v-show="_showDialogContainer && $store.getters.selectedDialog === 'AGB'"></Agb>
          <!--      <ItemDetail v-if="_showDialogContainer && $store.getters.selectedDialog === 'FoodDetail'"></ItemDetail>-->
          <!--      <DrinkItemDetail-->
          <!--        v-if="_showDialogContainer && $store.getters.selectedDialog === 'DrinkDetails'"></DrinkItemDetail>-->
          <PaymentMethods v-show="_showDialogContainer && $store.getters.selectedDialog === 'PaymentMethods'">
          </PaymentMethods>
          <TableQrCodeScanner v-show="_showDialogContainer && $store.getters.selectedDialog === 'TableQrCodeScanner'">
          </TableQrCodeScanner>
          <RatingFeedback v-if="_showDialogContainer && $store.getters.selectedDialog === 'RatingFeedback'"></RatingFeedback>
        </v-dialog>

        <!--        <div class="screensaver" v-if="showScreensaver"-->
        <!--             @click.passive="showScreensaver = false">-->
        <!--            <div class="superCenter" style="color:#888888; font-size: 2em">SCREEN LOCKED</div>-->
        <!--        </div>-->


        <!--    <div class="demoWartermark">-->
        <!--      ORDERMAXX DEMO<br>by Qsignal<sup>&reg;</sup>-->
        <!--    </div>-->

        <div style="position: absolute;top:0;">
          <div class="invisible all">{{ $store.getters.foodMenu }}</div>

          <Notification></Notification>
          <!--      <GlobalsLifecycle></GlobalsLifecycle>-->
          <UserLifecycle></UserLifecycle>
          <NewsLifecycle v-if="$store.state.enableNews"></NewsLifecycle>
          <FavoritesLifecycle v-if="$store.state.enableFavs"></FavoritesLifecycle>
          <GoogleGeopositionTool></GoogleGeopositionTool>
          <PushTrigger></PushTrigger>
          <OrderModeSwitchDialog
            :dialog="showOrderModeSwitchDialog"
            @close="showOrderModeSwitchDialog=false"
          ></OrderModeSwitchDialog>
          <KioskLifecycle></KioskLifecycle>
          <DiscountsLifecycle></DiscountsLifecycle>
          <PwaSelfCheck></PwaSelfCheck>

          <AndroidKioskLifecycle></AndroidKioskLifecycle>
        </div>

      </v-app>
    </div>

  </div>
</template>

<script>
// import * as iframe from './iframe/iframe'
// import * as debugOutput from './vendor/debugOutput'
import store from './store/store'
import * as breakpoints from './vendor/breakpoints'
import {getBtaste} from './vendor/bootstrap'
import {ebus} from './vendor/ebus';
import * as util from './vendor/util';
import * as sse from './vendor/sse'
import * as navigationState from './vendor/navigationState';
import * as qconst from './vendor/qconstants';
import * as couponUtil from './coupons/couponUtil';
import * as firebaseUtil from './firebase/firebaseUtil';

import * as appManager from './vendor/appManager'
import * as xhr from './api/xhr.js'
//TODO activate for online
import AppHead from "./components/AppHead";
// import ReferralHintDialog from "./dialogs/ReferralHintDialog";
// import OfferHintDialog from "./dialogs/OfferHintDialog";
// import OfferInfoDialog from "./dialogs/OfferInfoDialog";
// import CouponInfoDialog from "./dialogs/CouponInfoDialog";
import ShareDialog from "./dialogs/ShareDialog";
import QuestionDialog from "./dialogs/QuestionDialog";
import PwaPromoDialog from "./dialogs/PwaPromoDialog";
// import Sidebar from "./components/Sidebar";
import DsgvoDialog from "./dialogs/DsgvoDialog";
import Sidebar from "./components/Sidebar";
import {releaseWakelock, setUpWakelock} from "./services/wakelockService";
import {startVideo, stopVideo} from "./services/videoService";
import * as sound from './api/sound';
import UserLifecycle from "./lifecycle/UserLifecycle";
import InhouseLifecycle from "./lifecycle/InhouseLifecycle";
import StempelLogic from "./stempelkarte/StempelLogic";
import ItemDetail from "./views/ItemDetail";
import DrinkItemDetail from "./views/DrinkItemDetail";
import Notification from "./notifications/Notification";
import OfflineLifecycle from "@/lifecycle/OfflineLifecycle.vue";
import PaymentMethods from "@/views/PaymentMethods.vue";
import GangDialog from "@/dialogs/GangDialog.vue";
import NewsLifecycle from "@/news/NewsLifecycle.vue";
import FavoritesLifecycle from "@/favorites/FavoritesLifecycle.vue";
import RestoreCartItems from "@/lifecycle/RestoreCartItems.vue";
import {getGlobalValueOrZero, setGlobalKeyValue} from "@/util/globalState";
import TableQrCodeScanner from "@/views/TableQrCodeScanner.vue";
import IframeOverlay from "@/goodpay/IframeOverlay.vue";
import DebuggingConsole from "@/components/DebuggingConsole.vue";
import Agb from "@/views/AGB.vue";
import InventoryLifecycle from "@/lifecycle/InventoryLifecycle.vue";
import AddDirectlyHandler from "@/components/AddDirectlyHandler.vue";
import Search from "@/search/Search.vue";
import RatingFeedback from "@/feedback/RatingFeedback.vue";
import DialogBg from "@/components/DialogBg.vue";
import PushTrigger from "@/components/PushTrigger.vue";
import {errorReport} from "@/util/globalErrorHandler";
import {triggerSwDestroy} from "./util/globalErrorHandler";
import {cloneMe, doReload, isEmptyObject, roundToTwo} from "./vendor/util";
import {COUNTRY_CODE, CURRENCY_CODE, sseEnabled} from "./vendor/qconstants";
import {baseURL} from "./api/xhr.js";
import OrderModeSwitchDialog from "./orderModeSwitch/OrderModeSwitchDialog.vue";
import {removeGlobalKey} from "./util/globalState";
import {updateKioskStyle} from "./vendor/breakpoints";
import KioskLifecycle from "./kiosk/KioskLifecycle.vue";
// import SelectFiliale from "./views/SelectFiliale";
import MyPopup from "./components/MyPopup.vue";
import './webComponents/item-additionals.es';
import * as itemUtil from "./vendor/itemUtil";
import GoogleGeopositionTool from "./deliveryAreas/GoogleGeopositionTool.vue";
import {getCachedValue, setCachedKeyValue} from "./vendor/cacheUtil";
import DiscountsLifecycle from "./discounts/DiscountsLifecycle.vue";
import AndroidKioskLifecycle from "./androidkiosk/AndroidKioskLifecycle.vue";
import PwaSelfCheck from "./lifecycle/PwaSelfCheck.vue";
import {swUnregisterHelper} from "./vendor/pwaUtil";
import {appendCategoryNameToMenuItems} from "./vendor/itemUtil";
// import {offerMixin} from "./mixins/offerMixin";

export default {
  name: 'App',
  // mixins: [offerMixin],
  components: {
    PwaSelfCheck,
    AndroidKioskLifecycle,
    DiscountsLifecycle,
    GoogleGeopositionTool,
    MyPopup,
    KioskLifecycle,
    OrderModeSwitchDialog,
    PushTrigger,
    DialogBg,
    RatingFeedback,
    Search,
    AddDirectlyHandler,
    InventoryLifecycle,
    TableQrCodeScanner,
    Agb,
    DebuggingConsole,
    IframeOverlay,
    RestoreCartItems,
    FavoritesLifecycle,
    NewsLifecycle,
    GangDialog,
    PaymentMethods,
    OfflineLifecycle,
    Notification,
    DrinkItemDetail,
    ItemDetail,
    StempelLogic,
    UserLifecycle,
    InhouseLifecycle,
    // SelectFiliale,
    Sidebar,
    DsgvoDialog,
    PwaPromoDialog,
    QuestionDialog,
    ShareDialog,
    // CouponInfoDialog,
    // OfferInfoDialog,
    // OfferHintDialog,
    // ReferralHintDialog,
    AppHead
  },

  data: () => ({

    fullImageSrc: '',

    showOrderModeSwitchDialog: false,

    lastTryGetModifiedValues: 0,

    cr: '',

    _showSelectFiliale: false,

    isInApp: !!window.isoe,

    didScroll: false,
    pageSrollInterv: null,

    yA: 0,

    isOnline: true,
    foodCategories: [],
    appUsage: Date.now(),

    showBottomBack: false,

    enteredHome: Date.now(),

    lastAppSettingSaved: '',

    currentPushType: '',//'1' '2' '3'

    isInactive: false,
    drawer: null,
    // installDialog: false,
    // pwaTimer: '',

    showScrollDown: true,
    scrollPosition: 0,

    infoDialog: false,
    currentInfoTitle: '',
    currentInfoText: '',
    currentInfoImage: '',
    lastPwaUpdateInterval: null,
    swUpdateInterval: null,
    promoInterval: null,
    flagIgnoreInterval: false,


    offerHintDialog: false,

    shareDialog: false,

    showSnackbar: false,
    snackText: '',
    snackTime: 2000,

    showSheet: false,
    sheetText: '',

    currentCoupon: {},
    showPromo: false,

    showInstallPromo: false,

    currentReferralProgram: {},
    showReferralProgram: false,

    showDsgvoDialog: false,

    currentOfferId: '',
    offerInfoDialog: false,

    currentCallback: '',//for yes or no callbacks
    currentQuestion: '',
    currentQtext: '',
    currentQYesLabel: '',
    currentQNoLabel: '',
    currentYesAction: '',
    biggerYesButton: false,
    questionDialog: false,

    showGangDialog: false,
    showG1: false,
    showG2: false,
    showG3: false,

    //should be set to false only once
    initialScannedCouponWarning: true,

    displayAppVersion: '',

    duringInit: false,
    _showDialogContainer: false,
  }),

  computed: {

    primaryColor() {
      return getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-color').trim();
    },

    isMobile() {
      return store.getters.deviceClass !== 'md';
    },

    showDialogContainer() {
      this._showDialogContainer = !!this.$store.getters.showDialogContainer;
    },

    showSelectFiliale() {
      this._showSelectFiliale = !!this.$store.getters.showSelectFiliale;
    },
    // showBottomActions() {
    //     if (store.state.hideToolbar) {
    //         return false;
    //     }
    //     let rn = this.$route.name;
    //     if (rn) {
    //         return rn.indexOf('checkout') === -1;
    //     } else {
    //         return false;
    //     }
    // },
    itemsCount() {
      let i = 0;
      for (let item of store.getters.cartItems) {
        i += item.count;
      }
      return '' + i;
    },
  },

  watch: {
    '$route'(to, from) {
      try {
        this.updateDocTitle(to);

        this.showBottomBack = (to && to.name !== 'Home');
      } catch (e) {

      }
    },
    immediate: true
  },

  destroyed() {
    //only for iframe
    // iframe.destroy();
    // window.removeEventListener('scroll', this.handleScroll);
  },

  created() {

    ebus.$on('throwError', (err) => {
      if (!err) {
        return;
      }
      errorReport(err);
    });

    ebus.$on('itemAdditionalsWasUpdated', () => {
      this.updateWcProps();
    });

    ebus.$on('showOrderModeSwitchDialog', (v) => {
      this.showOrderModeSwitchDialog = v;
    });

    ebus.$on('pwaUpdateAvailable', (params) => {
      console.log('reload: lastPwaUpdate received pwaUpdateAvailable');
      this.lazyUpdatePwa();
    });

    // ebus.$on('lazyAddRemeberedItems', () => {
    //   this.lazyAddRemeberedItems();
    // });

    ebus.$on('doSignal', (text) => {
      this.doSignal(text);
    });

    ebus.$on('setDeviceClass', (deviceClass) => {
      store.commit('deviceClass', deviceClass);
    });

    ebus.$on('triggerLoadPages', () => {
      this.asyncLoadPages(true)
    });

    ebus.$on('triggerShowAdded', () => {
      store.commit('showAddedOverlay', true);
      setTimeout(() => {
        store.commit('showAddedOverlay', false);
      }, 700)
    });

    ebus.$on('shortcutToFoodMenu', () => {
      this.shortcutToFoodMenu();
    });

    ebus.$on('shortcutToDrinkMenu', () => {
      this.shortcutToDrinkMenu();
    });

    ebus.$on('loadFuidPoints', () => {
      this.loadFuidPoints();
    });

    //required for saving push token from UserLifecycle
    ebus.$on('saveAppSettings', () => {
      this.saveAppSettings();
    });

    // window.addEventListener('beforeunload', (e) => {
    //     //I CAN ACCESS TO this VARIABLE
    //     if (appManager.isInstallable() && !store.state.pwaInstalled) {
    //         console.log('unload PWA instalable');
    //         ebus.$emit('userWantsToInstall');
    //         // Cancel the event
    //         e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    //         // Chrome requires returnValue to be set
    //         e.returnValue = '';
    //     } else {
    //         console.log('unload PWA NOT instalable');
    //         // the absence of a returnValue property on the event will guarantee the browser unload happens
    //         delete e['returnValue'];
    //     }
    // }, false);

    ebus.$on('loadStores', (params) => {
      this.loadStores(params);
    });

    ebus.$on('goto', (params) => {
      this.goto(params);
    });

    ebus.$on('gotoPage', (params) => {
      this.gotoPage(params);
    });

    ebus.$on('cb-qrCodeRescan', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        ebus.$emit('showInfo', {
          title: 'Jetzt verlasse die App, scanne den QR-Code erneut und klicke dann auf "Browser öffnen"',
          text: ''
          // text: 'Hinweis: Der QR-Code bitte nicht innerhalb der QR-Code App öffnen, sondern im Browser öffnen.'
        });
      } else {
        // Adnroid App installieren
        let url = 'https://play.google.com/store/apps/details?id=com.scanteam.qrcodereader';
        ebus.$emit('gotoWebsite', url);
      }
    });


    ebus.$on('cb-jumpToCoupons', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        this.$router.push({name: 'Coupons'});
        // } else {
      }
    });

    ebus.$on('cb-pwa', (yesOrNo) => {
      //follow invitation of friend or not
      if (yesOrNo === 'yes') {
        let win = window.open('https://www.demo1.appcoast.eu/pwa.html', '_blank');
        win.focus();
      }
    });

    // ebus.$on('triggerUserUpsert', () => {
    //     this.upsertUserAccount();
    // });

    ebus.$on('testAcceptInvitation', () => {
      this.acceptInvitation();
    });

    //only for iframe
    // ebus.$on('mainScroll', (data) => {
    //     try {
    //         //calculate yA = offset from the iframe top to the center of the physical window
    //         let yOffset = Math.round(data.yOffset);
    //         let iTop = Math.round(data.iTop);
    //         let y50 = Math.round(data.vh / 2);
    //
    //         // console.log('yOffset = '+yOffset);
    //         // console.log('iTop = '+iTop);
    //         // console.log('y50 = '+y50);
    //         // console.log('*********************');
    //
    //         //1. calculate iOffset = offset between the begin of the viewport and the begin of the iframe
    //         let iOffset = yOffset - iTop;
    //
    //         //2. calculate yA the offset from the iframe top
    //         let yA = y50 + iOffset;
    //
    //         //now move the yA a bit to the top to make dialogs appear centered
    //         yA -= 100;
    //
    //         //Constaint 1) yA must be positibe
    //         if (yA < 0) {
    //             yA = 0;
    //         }
    //
    //         //Constraint 2) yA must not be at least 200px above the end of the iframe
    //         let iframeHeight = document.body.scrollHeight - 200;
    //         if (yA > iframeHeight) {
    //             yA = iframeHeight
    //         }
    //
    //
    //         //update v-dialog v-dialog--active
    //         document.querySelectorAll('.v-dialog').forEach((d) => {
    //             d.style.top = yA + 'px';
    //         });
    //
    //         // //update addedOverlay
    //         // document.querySelectorAll('.aoverlay').forEach((d) => {
    //         //     d.style.top = yA + 'px';
    // // });
    //
    //         store.commit('yA', yA);
    //
    //     } catch (e) {
    //         alert(e.message);
    //     }
    //
    // });

    ebus.$on('loadAppconfig', () => {
      this.loadAppconfig();
    });


    ebus.$on('storeCartForce', (cItems) => {
      if (cItems) {
        let items = util.cloneMe(cItems);
        let ci = {
          timestamp: Date.now(),
          items: items,
        };
        console.log('force store cartItems now: ' + JSON.stringify(ci));
        this.$ls.set('cartItems', ci);
      }
    });

    ebus.$on('storeCart', (cItems) => {
      if (cItems) {
        let items = util.cloneMe(cItems);
        if (items.length > 0) {
          let ci = {
            timestamp: Date.now(),
            items: items,
          };
          console.log('store cartItems now: ' + JSON.stringify(ci));
          this.$ls.set('cartItems', ci);
        }
      }
    });

    // ebus.$on(qconst.notify$foodsUpdated, () => {
    //     this.initFoodCats();
    // });


    ebus.$on('secTokenError', () => {
      console.log('got the event secTokenError');
    });
    ebus.$on('jwtInvalid', () => {
      console.log('got the event jwtInvalid');
    });

    ebus.$on('stopKeepAwake', () => {
      this.stopKeepAwake();
    });

    ebus.$on('startKeepAwake', () => {
      this.startKeepAwake();
    });

    ebus.$on('triggerSearchAnywhere', () => {
      this.triggerSearchAnywhere();
    });

    ebus.$on('showScrollDown', (show) => {
      this.showScrollDown = show;
    });

    ebus.$on('suggestQrCodeScan', (show) => {
      this.suggestQrCodeScan();
    });

    ebus.$on('showAlleFertigDialog', () => {
      this.showAlleFertigDialog();
    });

    ebus.$on('doConfirmAllReady', (table) => {
      this.doConfirmAllReady(table);
    });

    ebus.$on('localStoreIA', (ia) => {
      this.localStoreInvoiceAddress(ia);
    });

    // ebus.$on('localStoreDA', (da) => {
    //     this.localStoreDeliveryAddress(da);
    // });

    ebus.$on('orderSuccess', () => {
      //remove all coupons from store to ensure they are not getting promoted after redeeming
      store.commit('coupons', []);
      this.showPromo = false;

      setTimeout(() => {
        console.log('reload coupons after orderSuccess');
        this.loadCoupons(true)
      }, 15 * 1000);//ensure that the database has enough time to redeem the coupons
    });

    ebus.$on('addCouponToBasket', (c) => {
      this.addCouponToBasket(c);
    });

    ebus.$on('appOnline', () => {
      if (!this.isOnline) {
        this.isOnline = true;
        this.appFocused();
      } else if (!store.state.appLoaded) {
        console.log('call init() in appOnline');
        this.init();
      }
    });

    ebus.$on('appOffline', () => {
      this.isOnline = false;
    });

    // ebus.$on('cb-chooseUsecase', (yesOrNo) => {
    //     if (yesOrNo === 'yes') {
    //         let exp = 1 * 30 * 24 * 60 * 60 * 1000;//expiry 1 month
    //         this.$ls.set('introAbholung', {v: true}, exp);
    //     }
    // });

    // ebus.$on('cb-bvitFollow', (yesOrNo) => {
    //     //follow invitation of friend or not
    //     if (yesOrNo === 'yes') {
    //         this.$router.push({name: 'Registrierung'});
    //     }
    //     let exp = 24 * 60 * 60 * 1000;//expiry 1 day
    //     this.$ls.set('blockBivtr', true, exp);
    // });

    // ebus.$on('cb-bivtFriends', (yesOrNo) => {
    //     //invite friends yes or no
    //     if (yesOrNo === 'yes') {
    //         try {
    //             window.navigator.share({
    //                 title: 'Einladung erhalten!',
    //                 text: 'Jetzt 10% Rabatt Coupon freischalten in der App-Filiale von THEURER!',
    //                 url: 'https://' + window.location.hostname + '/?bivtr=' + bootstrap.getBtaste() + '#/Registrierung'
    //             }); // share the URL of MDN
    //         } catch (e) {
    //             console.log('Error in share: ' + e.message);
    //         }
    //     }
    // });

    ebus.$on('goBack', () => {
      this.goBack();
    });

    ebus.$on(qconst.notify$appLoaded, () => {
      // this.lazyShowInvitationHint();
    });

    ebus.$on('updateRelevantArea', () => {
      this.updateRelevantArea();
    });


    ebus.$on('enterRegister', () => {
      // setTimeout(() => {
      //     this.showbInvitation();
      // }, 600);//waite for the query params to be parsed
    });


    // ebus.$on('showStoreInfo', () => {
    //     this.gotoStoreInfo();
    // });

    ebus.$on('triggerFeedback', (asMessage) => {
      this.mailFeedback(asMessage);
    });

    ebus.$on('showQuestion', ({quest, text, yesLabel, noLabel, yesAction, cb, params}) => {
      if (!noLabel) {
        noLabel = '';
      }
      this.showQuestion(quest, text, yesLabel, noLabel, yesAction, cb, params);
    });


    ebus.$on('showGangDialog', ({showG1, showG2, showG3}) => {
      this.showG1 = showG1;
      this.showG2 = showG2;
      this.showG3 = showG3;
      this.showGangDialog = true;
    });


    // ebus.$on('accountCreated', () => {
    //     this.upsertUserAccount();
    //     setTimeout(() => {
    //         this.acceptInvitation();
    //     }, 800);
    // });

    ebus.$on('openCouponInfo', (couppon) => {
      this.openCouponInfo(couppon);
    });

    ebus.$on('closePromoDialog', () => {
      this.closeCouponInfoDialog();
      // this.closeOfferInfoDialog();
    });

    ebus.$on('closeSidebar', () => {
      this.drawer = false;
      navigationState.setSidebar(false);
    });

    ebus.$on('backHome', () => {
      console.log('backHome');
      if (navigator.onLine && (Date.now() - this.enteredHome > (10 * 1000))) {
        console.log('backHome longer than 10 seconds');
        // this.tryPwaTrigger();
      }
    });

    ebus.$on('openSidebar', (highlight) => {
      this.drawer = true;
      navigationState.setSidebar(true);
      if (highlight) {
        console.log('??? trigger greenPulsing animation now');
        try {
          setTimeout(() => {
            let punkt = document.querySelector('.' + highlight);
            if (punkt) {
              punkt.classList.remove('greenPulsing');
              punkt.classList.add('greenPulsing');
              setTimeout(() => {
                punkt.classList.remove('greenPulsing');
              }, 10 * 1000);
            }
          }, 50);
        } catch (err) {
          console.log('Error in animation: ' + err);
        }
      }
    });

    ebus.$on('NewContentAvailable', () => {
      console.log('reload: NewContentAvailable lastPwaUpdate');
      let now = Date.now();
      let easer = getGlobalValueOrZero('NewContentAvailable');
      if (!easer || now - parseInt(easer) > 2 * 60 * 1000) {
        setGlobalKeyValue('NewContentAvailable', now);
      } else {
        //eased
        console.log('reload: NewContentAvailable was eased');
        return;

      }
      console.log('reload: NewContentAvailable will reload in 2 seconds...');
      setTimeout(() => {
        console.log('reload: NewContentAvailable reload now');
        doReload('NewContentAvailable received');
        // window.location.reload();
      }, 2 * 1000);
    });

    ebus.$on('couponNow', (cc) => {
      this.$router.push({name: 'Einloesen', params: {couponCode: cc}});
      // let c = store.getters.getCouponByCode(coupon.couponCode);
      // let f = store.getters.selectedStore.strasse+ ', '+store.getters.selectedStore.ort;
      // if(c){
      //     ebus.$emit('showQuestion', {
      //         quest: 'Möchten Sie den Coupon "'+c.title+'" jetzt wirklich einlösen?',
      //         yesAction: null,
      //         qtext: 'Bitte zahlen Sie den Coupon an der Kasse der Filiale '+f+ '',
      //         yesLabel: 'Jetzt einlösen',
      //         cb: 'cb-couponNow'
      //     });
      // }
    });

    // ebus.$on('notifyNewsUpdated', (show) => {
    //     this.showScrollDown = show;
    // });


    ebus.$on('pageVisible', () => {
      console.log('lastPwaUpdate: pageVisible');
      this.appFocused();
    });

    ebus.$on('pageshow', () => {
      console.log('lastPwaUpdate: pageshow');
      this.appFocused();
    });

    ebus.$on('pageHidden', () => {
      console.log('lastPwaUpdate: pageHidden');
      this.appLostfocus();
    });
    ebus.$on('pageshide', () => {
      console.log('lastPwaUpdate: pageshide');
      this.appLostfocus();
    });
    ebus.$on('freeze', () => {
      console.log('lastPwaUpdate: freeze');
      this.appLostfocus();
    });

    ebus.$on('loadCoupons', (force) => {
      this.loadCoupons(!!force);
    });

    //P2P message for uid
    ebus.$on('notifyRewardReferrer', () => {
      this.loadCoupons();//reload coupons to fetch the reward
    });


    ebus.$on('viewedSomeItems', () => {
      // this.tryPwaTrigger();
    });

    ebus.$on('forceReload', () => {
      // alert('handle forceReload');
      this.$ls.set('lastMenuUpdate', Date.now());
      this.$ls.remove('lastFoodMod');
      this.$ls.remove('lastDrinkMod');
      doReload('forceReload event received')
      // window.location.reload();
      // doReload();
    });


    ebus.$on('reload', () => {
      // doReload();
    });

    ebus.$on('showOfferHint', () => {
      // store.commit('currentNext', 'order');
      this.offerHintDialog = true;
    });

    ebus.$on('showInfo', (info) => {
      this.currentInfoTitle = info.title;
      this.currentInfoText = '';
      if (info.text) {
        this.currentInfoText = info.text;
      }
      this.currentInfoImage = '';
      if (info.image) {
        this.currentInfoImage = info.image;
      }
      console.log('??? showInfo info.next = ' + info.next);
      if ('next' in info && typeof info.next !== 'undefined' && info.next.length > 0) {
        console.log('??? pass info.next');
        store.commit('currentNext', info.next);
      } else {
        console.log('??? do not pass info.next');
      }
      console.log('query in showInfo: ', info.query);
      if ('query' in info && typeof info.query !== 'undefined') {
        store.commit('currentQuery', JSON.stringify(info.query));
      }

      this.infoDialog = true;
      if (info.selfClosing) {
        setTimeout(() => {
          this.infoDialog = false;
        }, 2.5 * 1000);
      }
    });

    ebus.$on('toast', (textOrObj) => {
      if (typeof textOrObj === 'string') {
        this.toast(textOrObj);
      } else {
        this.toast(textOrObj.msg, textOrObj.time);
      }
    });

    ebus.$on('info', (text) => {
      this.info(text);
    });

    ebus.$on('stripeLoaded', () => {
      store.commit('stripeLoaded', true);
    });

    ebus.$on('openGooglePay', () => {
      this.openGooglePay();
    });

    ebus.$on('openApplePay', () => {
      this.openApplePay();
    });

    ebus.$on('shareApp', () => {
      this.shareApp();
    });

    ebus.$on('loadLastOrders', (params) => {
      console.log('on loadLastOrders');
      this.loadLastOrders(false, params);
    });


    ebus.$on('gotoStart', (withReplace) => {
      this.gotoStart(!!withReplace);
    });

    ebus.$on('pwaInstallable', () => {
      console.log('pwaInstallable !!!!!!!!!');
      if (!store.state.pwaInstalled) {
        store.commit('showInstallPwa', true);
      }
    });

    ebus.$on('installPrompt', (force) => {
      ebus.$emit('userWantsToInstall');
      // // this.installDialog = true;
      // // store.commit('showInstallPwa', true);
      // if (force || !store.getters.inhouse) {
      //   this.showInstallPromo = true;
      // }
      // // this.waitForInstallPromo();
    });


    ebus.$on('userWantsToInstall', () => {
      if (appManager.isStandalone()) {
        ebus.$emit('toast', 'Die App ist bereits installiert');
        return
      }

      this.userWantsToInstall();
    });

    // this.pwaTimer = setInterval(this.checkPwaInstalled, 3 * 60 * 1000);
    ebus.$on('installationCompleted', () => {
      this.installDialog = true;
      store.commit('pwaInstalled', true);
      store.commit('showInstallPwa', false);
      // try {
      //     util.clearTheInterval(this.pwaTimer);
      // } catch (e) {
      //
      // }
    });

    // ebus.$on('deleteCacheStorage', () => {
    //     this.deleteCacheStorage();
    // });

    ebus.$on('checkDsgvo', (force) => {
      this.checkDsgvo(force);
    });

    ebus.$on('finishDsgvo', () => {
      this.finishDsgvo();
    });

    ebus.$on('sse-eventbus.connected', () => {
      console.log('sse-eventbus.connected');
      // store.commit('showConnectionLost', false);
    });

    ebus.$on('sse-eventbus.disconnected', () => {
      console.log('sse-eventbus.disconnected');
    });

    ebus.$on('outboundAction', oa => {
      if (oa.outboundAction === 'UPDATE_TABLE_GROUP') {
        if (store.getters.isGroupSelected && oa.tableString === ('' + store.getters.table)) {

          try {
            let groups = cloneMe(store.getters.tableGroups);
            let theGroup = groups.find(g => g.tableString === oa.tableString && g.groupName === oa.groupName);
            let myMember = theGroup.members.find(m => m.deviceId === getBtaste());
            let otherMembers = oa.group.members.filter(m => m.deviceId !== getBtaste()); //do not update my own cartItems from oa
            let combined = [].concat(otherMembers);
            combined.unshift(myMember);
            theGroup.members = combined;
            store.commit('tableGroups', groups);
            console.log('UPDATE_TABLE_GROUP tableGroups updated');
          } catch (e) {

          }

          // store.commit('updateTableGroup', {
          //   tableString: oa.tableString,
          //   groupName: oa.groupName,
          //   group: oa.group,
          // });
        }
      } else if (oa.outboundAction === 'orderUpdated') {
        console.log('<<============== ORDER UPDATED RECEIVED');
        store.commit('updateOrder', oa.order);
        if (oa.order.state === qconst.orderState$Confirmed
          && this.$route.path.indexOf('Bestaetigung') !== -1) {
          let lastOrder = this.$ls.get('lastOrder', false);
          if (lastOrder) {
            this.$router.push({name: 'Bestellung', params: {uniqueOrderId: lastOrder.uniqueOrderId}});
          } else {
            this.gotoStart();
          }
        }
      } else if (oa.outboundAction === 'offersUpdated') {
        if (oa.offers) {
          store.commit('offers', oa.offers);
        }
        if (oa.offerPromotions) {
          store.commit('offerPromotions', oa.offerPromotions);
        }

        ebus.$emit('offersUpdated');
        // } else if (oa.outboundAction === 'takeawayDataUpdated') {
        //     //gets send by the ordertablet when dcontext changes
        //     if (oa.takeawayData) {
        //         this.initTakeawayData(oa.takeawayData);
        //     }
      } else if (oa.outboundAction === 'newsUpdated') {
        if (oa.news) {
          store.commit('news', oa.news);
        }
      }
    });

    window.addEventListener('scroll', this.handleScroll);


    //add listener to storageEvent
    // let _this = this;
    // let origLsSetItem = this.$ls.set;
    // this.$ls.set = function setItem() {
    //     let key = arguments[0];
    //     console.log('localStorage event on ' + key);
    //     if (key === 'newsRead') {
    //         _this.updateNewsRead(JSON.parse(arguments[1]).value);
    //     }
    //     origLsSetItem.apply(localStorage, arguments);
    // };
    // this.$ls.on('newsRead', function (val) {
    //     console.log('Listener for newsRead: val = ' + JSON.stringify(val));
    //     _this.updateNewsRead(val);
    // });
    //listen for storage chagnes

    ebus.$on('gotoWebsite', (url) => {
      this.gotoWebsite(url);
    });

    ebus.$on('pullBuyersProfile', () => {
      let u = firebaseUtil.getUser();
      let fuid = null;
      if (u) {
        fuid = u.uid;
      }
      this.pullBuyersProfile(fuid)
    });

  },

  beforeMount() {
    setGlobalKeyValue('keepInstance', true);

    let isInstalled = appManager.isStandalone();
    // console.log('??? is installed: ' + isInstalled);
    store.commit('pwaInstalled', isInstalled);
    setGlobalKeyValue('keepInstance', true);
    //only for iframe
    // iframe.init();
  },

  // activated() {
  //     //only for iframe
  //     // iframe.init();
  //     // iframe.post_startRender();
  //     this.av();
  //     this.restoreCartItems();
  // },

  mounted() {
    this.checkStoragePersist();

    // if (store.getters.isKiosk) {
    //   this.optimizeViewportForKiosk(1800);
    // } else {
    //   console.log('optimizeViewportForKiosk ignored because isKiosk=false')
    // }

    // //only for iframe
    // iframe.post_startRender();
    // iframe.post_size(true);

    // if (store.getters.isKiosk) {
    //   setTimeout(() => {
    //     this.resetKiosk();
    //   }, 1.5 * 60 * 1000)
    // }

    setInterval(() => {
      this.lazyPullMenus();
      this.loadAppconfig()
      store.commit('triggerRefreshFoodMenu', true)
      store.commit('triggerRefreshDrinkMenu', true)
    }, 20 * 1000);

    try {
      window.loadCustomCSS().then(() => {
      }, () => {
      });
    } catch (e) {
      console.log('error in loadCustomCss', e);
    }

    this.loadCustomJS().then(() => {
    }, () => {
    });

    this.loadds().then(() => {
    }, () => {
    });

    this.initCr();

    // this.restoreCartItems();

    // document.getEleupdateDocTitle mentById('iloader').style.display = 'none';
    this.init(true);
    this.updateDocTitle(null);

    //enable analytics after DSKVO in finishDsgvo
    // firebaseUtil.initAnalytics();

    this.checkMissingFeatures();

    setTimeout(() => {
      if (store.state.enableSelfServiceExtras && !store.getters.isKiosk) {
        sound.init();
      }
      console.log('beep sound finishInit');
    }, 10 * 1000);

    this.av();
    // this.restoreCartItems();

    ebus.$emit('loadStempelkarte', {retry: true});

    // setTimeout(() => {
    //   this.tryPwaTrigger();
    // }, 5000);

    setTimeout(() => {
      this.lazyPullMenus();
    }, 90 * 1000);

    this.lazyPullMenus();

    if (store.state.forceOrderModeSelectionOnOpen) {
      store.commit('setSelectedOrderModeByUser', '');
      ebus.$emit('showOrderModeSwitchDialog', true);
    }
    // if (store.getters.isKiosk) {
    //   document.body.style.fontSize = '22px'
    //   document.documentElement.style.fontSize = '22px'
    // }

  },

  methods: {
    // optimizeViewportForKiosk(targetWidth) {
    //   if (!targetWidth) {
    //     return;
    //   }
    //   const app = document.getElementById('smartAppContainer');
    //   if (!app) return;
    //
    //   const root = document.documentElement; // ist das HTML-element
    //   // const body = document.body;
    //
    //   const w = window.innerWidth;
    //   const h = window.innerHeight;
    //
    //   // 1. Der Skalierungsfaktor basiert IMMER auf der Breite
    //   const scaleFactor = w / targetWidth;
    //   root.style.setProperty('--kiosk-scale', 'scale(' + scaleFactor + ')');
    //
    //   // 2. Die logische Höhe unter Beibehaltung der Aspect Ratio berechnen
    //   // Wir projizieren das echte Seitenverhältnis auf unsere targetWidth Basis
    //   const logicalHeight = h / scaleFactor;
    //
    //   // 3. Transformationen anwenden
    //   app.style.transform = `scale(${scaleFactor})`;
    //   app.style.transformOrigin = "top left";
    //   app.style.width = targetWidth + "px";
    //   app.style.minHeight = logicalHeight + "px";
    //   app.style.zIndex = "3";
    //   app.style.height = "auto"; // Erlaubt dem Body, mit dem Content zu wachsen
    //   root.style.overflowX = "hidden";
    //   // app.style.position = "absolute";
    //   // app.style.margin = "0";
    //
    //   // 4. CSS Variablen für das Layout-System (DPI-Ersatz)
    //   root.style.setProperty('--layout-width', targetWidth + "px");
    //   root.style.setProperty('--layout-height', logicalHeight + "px");
    //
    //   document.body.classList.add('is-kiosk');
    //
    //   // http://localhost:8080/?kiosk=777#/debugParams
    // },

    // openItemAdditionals() {
    //   this.$store.commit('showItemAdditionals', true);
    //   this.$store.dispatch('openMyPopup');
    //   ebus.$emit('itemAdditionalsWasUpdated');
    // },

    closeItemAdditionals() {
      this.$store.commit('showItemAdditionals', false);
      this.$store.dispatch('closeMyPopup');
    },

    clickArticleImage(event) {
      console.log('clickArticleImage  event.detail=' + event.detail);
      this.fullImageSrc = event.detail;
    },

    prepareAddToCart(event) {
      let selectionData = JSON.parse(event.detail);
      console.log('prepareAddToCart... ', selectionData);

      try {
        if (!selectionData.article.extras) {
          selectionData.article.extras = {};
        }
        if (!selectionData.article.extras.variants) {
          selectionData.article.extras.variants = [];
        }
      } catch (e) {
        console.log('error in prepareAddToCart', e);
      }

      let item = selectionData.article;

      //Check if unikat is already in cart
      if (item.unikat) {
        for (let itm of store.getters.cartItems) {
          if (itm.id === this.item.id) {
            return;
          }
        }
      }

      if (this.doAddToCart(selectionData)) {
        this.closeItemAdditionals();
      }

    },

    getSumOfExtras(item, selectedVariants) {
      let result = {
        sumOfSteps: 0,
        sumOfExtras: 0,
        hasVolCosts: false
        // '30 cm': 0.7,
        // '40 cm': 1.57
      };

      try {
        if (item?.extras?.variants) {

          for (const [key, value] of Object.entries(selectedVariants)) {
            let variantTitle = key;
            let selectedOptionId = value;

            let fullStep = item.extras.variants.find(v => v.title === variantTitle);
            if (fullStep) {

              //add variants cost
              for (let variant of item.extras.variants) {
                let freeArticles = variant.freeArticles ? variant.freeArticles : 0;
                //ignore replaceArticle steps while calculating extras
                if (!variant.replaceArticle && variant.options) {
                  let selectedArticles = 0;
                  for (let option of variant.options) {
                    if (option.id === selectedOptionId) {
                      ++selectedArticles;
                      if (selectedArticles > freeArticles) {
                        result.sumOfSteps += option.cost;
                      }
                    }
                  }
                }
              }

            }
          }
        }
      } catch (e) {
        // alert('Error in getSumOfExtras: ' + JSON.stringify(e))
      }

      return result;
    },

    getSizePrices(size, isMultiSize, quantity, sumOfExtras) {
      let sizePrices = {
        sizeTotal: size.price * quantity,
        sumOfExtras: 0
      };

      if (size.takeAwayPrice) {
        sizePrices.sizeTakeAwayTotal = (size.takeAwayPrice * quantity);
      }
      if (size.deliveryPrice) {
        sizePrices.sizeDeliveryTotal = (size.deliveryPrice * quantity);
      }

      // console.log('sizePrices.sizeTakeAwayTotal = '+sizePrices.sizeTakeAwayTotal);
      // console.log('sizePrices.sizeTotal = '+sizePrices.sizeTotal);

      console.log('??? sumOfExtras = ' + JSON.stringify(sumOfExtras));

      if (isMultiSize && sumOfExtras.hasVolCosts) {
        //Multiply by size selections
        sizePrices.sumOfExtras = (sumOfExtras.sumOfSteps + sumOfExtras[size.vol]) * quantity;
      } else {
        //Multiply by size selections
        sizePrices.sumOfExtras = (sumOfExtras.sumOfSteps + sumOfExtras.sumOfExtras) * quantity;
      }

      return sizePrices;
    },

    doAddToCart: function (selectionData) {
      try {
        let itemToAdd = cloneMe(selectionData.article);
        let variants = cloneMe(itemToAdd.extras.variants);
        let theItemId = '' + itemToAdd.id;
        let quantity = selectionData.quantity;
        const totalPrice = selectionData.totalPrice;
        let sizeTotal = roundToTwo(totalPrice / quantity);
        let sizePrice = sizeTotal;
        try {
          sizePrice = itemToAdd.sizes[0].price;
        } catch (e) {
          console.log('error in doAddToCart itemTotal', e);
        }
        const sumOfExtras = sizeTotal - sizePrice;


        let itemType = itemToAdd.itemType || qconst.type$foodOrder;
        let selectedSize = selectionData.selectedSize || '';
        let selectedVariants = selectionData.selectedVariants;

        console.log('doAddToCart from item-additionals with selectionData ', selectionData);

        if (itemToAdd.sizes?.length && itemToAdd.sizes.length === 1) {
          selectedSize = itemToAdd.sizes[0].vol;
        }

        for (let i = 0; i < quantity; i++) {
          let itemClone = util.cloneMe(itemToAdd);

          let anySize = false;

          //Add one item for every size
          if (itemClone.sizes) {

            for (let size of itemClone.sizes) {

              if (size.vol !== selectedSize) {
                continue;
              }

              anySize = true;

              let extrasToDisplay = [];
              let variantsSelected = []; //array of selected options (full objects)
              let extras = [];
              const selectedVariantsEntries = Object.entries(selectedVariants);
              for (const [key, arrayOfIds] of selectedVariantsEntries) {
                let variantTitle = key;
                let selectedOptionIds = arrayOfIds;

                let fullSteps = variants.filter(v => v.title === variantTitle);
                const fullStep = {}; //united
                let isFirstStep = true;
                for (let step of fullSteps) {
                  if (isFirstStep) {
                    Object.assign(fullStep, step)
                    isFirstStep = false;
                  } else {
                    let combinedOptions = fullStep.options || [];
                    if (step.options?.length) {
                      step.options.forEach(o => {
                        combinedOptions.push(o);
                      });
                    }
                    fullStep.options = combinedOptions;
                  }
                }
                if (fullStep && !isEmptyObject(fullStep)) {
                  let selectedOptions = fullStep.options.filter(o => o && selectedOptionIds.includes(o.id));
                  for (let so of selectedOptions) {
                    extrasToDisplay.push(so.labelDE);
                    variantsSelected.push(so);
                    extras.push({
                      name: so.labelDE,
                      posId: so.posId,
                      price: so.cost,
                    });
                  }
                }
              }

              // yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy

              // let sumOfExtras = this.getSumOfExtras(itemToAdd, selectedVariants).sumOfSteps;

              let cat = null;
              if (itemType === qconst.type$drinkOrder) {
                cat = store.getters.getDrinkCategoryByItemId(theItemId);
              } else {
                cat = store.getters.getCategoryByItemId(theItemId);
              }

              let item = {
                sourceItem: itemClone,
                categoryDE: itemClone.categoryDE,
                id: itemClone.id,
                articleNo: '',
                posId: itemClone.posId,
                delay: cat.delay || 0,
                cartItemId: util.generateClientId(),
                isOffer: !!(size.offerId), //offers and cartItems ar always size specific
                type: itemType,
                nameToDisplay: itemClone.nameDE,
                description: '' + itemClone.descriptionDE,
                // days: itemClone.days,
                notes: '',
                gramm: itemClone.gramm,
                unikat: !!(itemClone.unikat),
                // lieferzeit: '' + itemClone.lieferzeit,
                // kilopreis: '' + itemClone.kilopreis,
                // streichPreis: itemClone.streichPreis,
                // sumOfExtras: sumOfExtras,
                sizePrice: sizePrice,
                // takeAwaySizePrice: size.price,
                // deliverySizePrice: size.price,
                // nameEN: thisFood.nameEN,
                sumOfExtras: sumOfExtras,// this.total - (size.price * size.aaaCount),
                itemTotal: sizePrice + sumOfExtras,
                // takeAwayItemTotal: sizePrices.sizeTotal + sizePrices.sumOfExtras,
                // deliveryItemTotal: sizePrices.sizeTotal + sizePrices.sumOfExtras,
                count: 1,
                vol: size.vol,
                extras: extras,
                // variantsToDisplay: [],
                extrasToDisplay: extrasToDisplay,
                // extrasEN: [], //['value one', 'value two' ] //or empty array
                variantsSelected: variantsSelected,
                stylesSelected: [] //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
              };

              if (itemClone.notes) {
                item.notes = itemClone.notes;
              }
              if (!store.state.enableBestand) {
                item.hasBestand = false;
                item.bestand = -1;
              } else if (itemClone.bestand !== -1) {
                item.hasBestand = true;
                item.bestand = itemClone.bestand;
              }
              if (itemClone.ticket) {
                item.ticket = itemClone.ticket;
                item.type = qconst.type$generic;
              }
              if (itemClone.articleNo) {
                item.articleNo = itemClone.articleNo;
              }
              if (itemClone.days) {
                item.days = itemClone.days;
              }
              if (itemClone.onlineGutschein) {
                item.onlineGutschein = true;
              }
              if (itemClone.offlineGutschein) {
                item.offlineGutschein = true;
              }

              // if (config && config.additionalProps) {
              //   Object.keys(config.additionalProps).forEach((key) => {
              //     item[key] = config.additionalProps[key];
              //   });
              // }

              item.articleNo = this.getArtikelnummerOfItem(itemClone, selectedVariants);

              let selectionOtionOfReplaceArticle = this.getSelectedOptionOfReplaceArticleStep(itemClone, selectedVariants);

              if (selectionOtionOfReplaceArticle) {
                item.posId = selectionOtionOfReplaceArticle.posId;

                //append the posId of the main article because Lightspeed required the main article
                item.mainPosId = item.posId;
              }

              if (size.offerId) {
                item.offerId = size.offerId;
                item.offerName = '';
                item.offerUsecase = '';

                let offer = store.getters.getOfferById(size.offerId);
                if (offer) {
                  item.offerName = offer.name;
                  item.offerUsecase = offer.usecase;
                }
              }

              console.log('doAddToCart item: ', item);

              setGlobalKeyValue('userWantsToAddItemToCart', {item: cloneMe(item), count: 0 + quantity});
              store.commit('addItemToCart', {item: item});
              if (store.getters.cartItems.length > 0) {
                removeGlobalKey('userWantsToAddItemToCart');
              }
              if (this.$store.getters.showDialogContainer) {
                this.$store.commit('showDialogContainer', false);
              }

            }//eof size loop
          }
        }
        return true;
      } catch (err) {
        console.log('error in doAddToCart: ' + err.message);
        return false;
      }
    },

    getSelectedOptionOfReplaceArticleStep(item, selectedVariants) {
      for (const [key, value] of Object.entries(selectedVariants)) {
        let variantTitle = key;
        let selectedOptionId = value;

        let fullStep = item.extras.variants.find(v => v.title === variantTitle);
        if (fullStep) {
          if (fullStep.replaceArticle) {
            const options = fullStep.options;
            let selectedOption = options.find(o => o?.id && o.id === selectedOptionId[0]);
            if (selectedOption) {
              return selectedOption;
            }
          }
        }
      }
      return null;
    },

    getArtikelnummerOfItem(item, selectedVariants) {
      let code = '';
      if (item.articleNo) {
        code = item.articleNo;
      }

      for (const [key, value] of Object.entries(selectedVariants)) {
        let variantTitle = key;
        let selectedOptionId = value;

        let fullStep = item.extras.variants.find(v => v.title === variantTitle);
        if (fullStep) {
          if (fullStep.multi || !fullStep.replaceArticle) {
            continue;
          }
          let selectedOption = fullStep.options.find(o => o && o.id === selectedOptionId);
          if (selectedOption) {
            if (so.articleNo) {
              code = so.articleNo;
              break;
            }
          }
        }
      }

      return code;
    },

    updateWcProps() {
      this.$nextTick(() => { // ✅ Ensure component is mounted
        if (this.$refs.wc_item_additionals) {
          this.$refs.wc_item_additionals.primaryColor = this.primaryColor;

          let articleToShowInPopup = getGlobalValueOrZero('articleToShowInPopup');
          console.log('articleToShowInPopup = ' + articleToShowInPopup);
          if (articleToShowInPopup) {
            this.$refs.wc_item_additionals.itemType = articleToShowInPopup.itemType;
            this.$refs.wc_item_additionals.article = JSON.stringify(articleToShowInPopup);
            this.$refs.wc_item_additionals.currency = CURRENCY_CODE;
            this.$refs.wc_item_additionals.language = COUNTRY_CODE;
          }
        }
      });
    },

    closeMyPopup() {
      this.$store.dispatch('closeMyPopup');
    },
    readyForNextPwaUpdateCheck() {
      let lastPwaUpdate = this.$ls.get('lastPwaUpdate') || 0;
      if (!lastPwaUpdate || (Date.now() - lastPwaUpdate) > (1 * 60 * 1000)) {
        return true;
      }
      console.log('reload: ignore pwaUpdate because lastPwaUpdate was earlier than 1 minutes');
      return false;
    },
    lazyUpdatePwa() {
      console.log('reload: readyForNextPwaUpdateCheck=' + (!!this.readyForNextPwaUpdateCheck()));
      if (this.readyForNextPwaUpdateCheck()) {
        this.$ls.set('lastPwaUpdate', Date.now());
        window.location.reload();
      }
    },
    async checkStoragePersist() {
      try {
        console.log('checkStoragePersist...');
        if (navigator.storage && navigator.storage.persist) {
          const persistent = await navigator.storage.persist();
          this.$ls.set('storageIsPersistent', persistent);
          if (persistent) {
            console.log('StoragePersist will not be cleared except by explicit user action');
          } else {
            console.log('StoragePersist may be cleared by the UA under storage pressure.');
          }
        }
      } catch (error) {
        console.error('An error occurred checking StoragePersist:', error);
      }
    },
    async doSignal(text) {
      let msg = {
        action: qconst.action$Kellnerruf,
        usecase: qconst.usecase$kellnerruf,
        type: text,
        table: store.getters.table,
        signalId: util.generateClientId(),
      };
      await xhr.xhrSend(true, msg, (reply) => {
        if (reply.ok) {
          console.log('doSignal was ok');
          ebus.$emit('cb-doSignal', text);
        } else {
          console.log('error: doSignal was notok');
          ebus.$emit('cb-doSignal', false);
        }
      }, (err) => {
        console.log('doSignal was ok: ' + err);
      });
    },

    // lazyAddRemeberedItems() {
    //   let itemAndCount = getGlobalValueOrZero('userWantsToAddItemToCart');
    //   if (itemAndCount) {
    //     for (let i = 0; i < itemAndCount.count; i++) {
    //       let item = cloneMe(itemAndCount.item);
    //       store.commit('addItemToCart', {item: item});
    //     }
    //     removeGlobalKey('userWantsToAddItemToCart');
    //   }
    // },

    shortcutToFoodMenu() {
      let cats = util.cloneMe(store.getters.foodMenu);
      let relevant = [];
      for (let cat of cats) {
        if (!cat.items) {
          continue;
        }
        relevant.push(cat);
      }
      if (relevant.length === 1) {
        this.$router.push({name: 'SpeisenProdukte', params: {catname: relevant[0].categoryDE}});
      } else {
        this.$router.push({name: 'Speisen'});
      }
    },
    shortcutToDrinkMenu() {
      let cats = util.cloneMe(store.getters.drinkMenu);
      let relevant = [];
      for (let cat of cats) {
        if (!cat.items) {
          continue;
        }
        relevant.push(cat);
      }
      if (relevant.length === 1) {
        this.$router.push({name: 'GetraenkeProdukte', params: {catname: relevant[0].categoryDE}});
      } else {
        this.$router.push({name: 'Getraenke'});
      }
    },
    loadFuidPoints() {
      this.loadStempelkarte();
    },
    checkMissingFeatures() {
      try {
        if (store.getters.selfServiceEnabled) {
          let lsAvailable = false;
          if (typeof localStorage !== 'undefined') {
            try {
              localStorage.setItem('feature_test', 'yes');
              if (localStorage.getItem('feature_test') === 'yes') {
                localStorage.removeItem('feature_test');
                lsAvailable = true;
              } else {
                // localStorage is disabled
              }
            } catch (e) {
              // localStorage is disabled
            }
          } else {
            // localStorage is not available
          }
          if (!lsAvailable) {
            ebus.$emit('showQuestion', {
              quest: 'Bitte scanne den QR-Code erneut und benutze danach den Button "Browser öffnen"',
              text: 'Kurzanleitung:<br><ul>' +
                '<li>iPhones: Nutze die Standard-Kamera, keine App notwendig</li>' +
                '<li>Android-Phones: Probiere die Standard-Kamera aus, ansonsten installiere die empfohlene QR-Code App</li>' +
                '</ul>' +
                '',
              yesLabel: 'Ok',
              noLabel: 'Zur empfohlenen QR-Code App',
              // yesAction: null,
              cb: 'cb-qrCodeRescan'
            });
          }
        }
      } catch (e) {
        console.log('Error in lsAvailable: ' + e.message);
      }

      // try{
      //     if (this.$store.getters.inhouse && store.state.enableSelfServiceExtras) {
      //         if (window.isoe) {
      //             ebus.$emit('showQuestion', {
      //                 quest: 'Bitte scanne den QR-Code erneut und benutze danach den Button "Browser öffnen"',
      //                 text: 'Kurzanleitung:<br><ul>' +
      //                     '<li>iPhones: Nutze die Standard-Kamera, keine App notwendig</li>' +
      //                     '<li>Android-Phones: Probiere die Standard-Kamera aus, ansonsten installiere die empfohlene QR-Code App</li>' +
      //                     '</ul>' +
      //                     '',
      //                 yesLabel: 'Ok',
      //                 noLabel: 'Zur empfohlenen QR-Code App',
      //                 // yesAction: null,
      //                 cb: 'cb-qrCodeRescan'
      //             });
      //         }
      //     }
      // }catch (e) {
      //     console.log('Error in checkMissingFeatures: '+e.message);
      // }
    },
    initCr() {
      // console.log('cr: initCr...');
      // try {
      //   let challange = window.qcrChallange;
      //   if (!challange) {
      //     //retry
      //     setTimeout(() => {
      //       this.initCr();
      //     }, 200);
      //   } else {
      //     let salt = window.qcrSalt;
      //     let params = challange.split('|');
      //     let p1 = params[0];
      //     let p2 = params[1];
      //     let p3 = params[2];
      //     let s = '' + p1;
      //     for (let i = 0; i < p2; i++) {
      //       s += '' + i
      //     }
      //     console.log('cr: s = ' + s);
      //     let l = parseFloat(s);
      //     this.cr = '' + ((l * p3) + salt);
      //     console.log('this.cr: this.cr = ' + this.cr);
      //
      //     this.getSecToken();
      //
      //   }
      // } catch (e) {
      //   //retry
      //   setTimeout(() => {
      //     this.initCr();
      //   }, 2000);
      // }
    },
    async loadCustomJS() {
      let ns = document.createElement("script");
      ns.src = 'custom.js?t=' + Date.now();
      document.body.appendChild(ns);
    },
    async loadds() {
      // let ns = document.createElement("script");
      // ns.src = '/sec/v1/dynScript.js';
      // document.body.appendChild(ns);
    },
    getSecToken() {
      // if (bootstrap.getBtaste().length < 25) {
      //   setTimeout(() => {
      //     this.getSecToken();
      //   }, 200);
      //   console.log('wait for btaste and retry...');
      // } else {
      //   let msg = {
      //     action: qconst.action$GetSecToken,
      //     cr: this.cr,
      //   };
      //   xhr.xhrSend(true, msg, (data) => {
      //     console.log('cr: secToken = ', data);
      //     if (data && data.ok && data.secToken) {
      //       xhr.setSecToken(data.secToken);
      //       this.$store.commit('secToken', data.secToken);
      //       setTimeout(() => {
      //         this.$store.commit('secToken', data.secToken);
      //       }, 5000);
      //     } else {
      //       window.qcrChallange = false;
      //       this.loadds().then(() => {
      //       }, () => {
      //       });
      //       setTimeout(() => {
      //         this.initCr();
      //         // setTimeout(() => {
      //         //     doReload();
      //       }, 1000);
      //     }
      //   }, (err) => {
      //     // logError('Load orders');
      //     window.qcrChallange = false;
      //     this.loadds().then(() => {
      //     }, () => {
      //     });
      //     this.initCr();
      //     console.log('??? Error in getSecToken: ', JSON.stringify(err));
      //   });
      // }
    },

    considerDefaultView() {
      // if (this.$store.getters.inhouse) {
      //   let jumpToOrderId = this.getJumpToOrderId();
      //   if (jumpToOrderId) {
      //     ebus.$emit('startKeepAwake');
      //     this.$router.push({name: 'Bestellung', params: {uniqueOrderId: jumpToOrderId}});
      //   } else {
      //     // ebus.$emit('showInfo', {
      //     //     title: 'Deine Bestellung ist jetzt abholbereit!',
      //     //     text: ''
      //     // });
      //     setTimeout(() => {
      //       ebus.$emit('stopKeepAwake');
      //     }, 3 * 60 * 1000)
      //   }
      // }
    },

    getJumpToOrderId() {
      if (store.getters.selfServiceEnabled) {
        let rn = this.$route.name;
        if (rn !== 'Bestellung') {
          let orders = store.getters.lastOrders;
          if (orders.length > 0) {
            let o = orders[0];
            if (util.isKilled(o)) {
              return '';
            }
            if (o.usecase === qconst.usecase$takeAway || o.usecase === qconst.usecase$tableOrdering) {
              let targetTime = o.targetTime;
              if (!targetTime) {
                if (o.usecase === qconst.usecase$tableOrdering) {
                  targetTime = o.createdAt + (5 * 60 * 1000);
                } else {
                  return '';
                }
              }
              let n = new Date();
              let sameD = util.isSameDay(new Date(targetTime), n);
              if (sameD &&
                //target nicht zu weit in der Zukunft
                (targetTime - n.getTime() < (60 * 60 * 1000)) &&
                //target nicht zu weit in der Vergangenheit
                (n.getTime() - targetTime < (10 * 60 * 1000))) {
                let oid = o.uniqueOrderId;
                if (oid) {
                  return oid;
                }
              }
            }
          }
        }
      }
      return '';
    },

    gotoWebsite(url) {
      let win = window.open(url, '_blank');
      win.focus();
    },

    handleScroll() {
      this.didScroll = true;
    },

    showAlleFertigDialog() {
      if (qconst.enableAllReady) {
        ebus.$emit('showQuestion', {
          quest: 'Haben alle Personen am Tisch bestellt?',
          // ' und sehen einen grünen Bestätigungs-Hacken?',
          // text: '',
          yesLabel: 'Ja, wir sind fertig',
          noLabel: 'Nein',
          // yesAction: null,
          cb: 'cb-confirmAllready'
        });
      }
    },

    clearPageScoller() {
      try {
        window.removeEventListener('scroll', this.handleScroll);
      } catch (e) {
      }
      try {
        util.clearTheInterval(this.pageSrollInterv);
      } catch (e) {
      }
    },

    initPageScrollThrottler() {
      this.pageSrollInterv = setInterval(() => {
        if (this.didScroll) {
          this.didScroll = false;

          //Anything
        }
      }, 500);
    },

    async init(initial) {
      //only for test
      // setTimeout(()=>{
      //     this.showInstallPromo = true;
      // }, 5000);

      try {
        console.log('Init()...');
        this.av();
        breakpoints.updateDeviceClass();
        if (store.getters.isKiosk) {
          updateKioskStyle();
        }
        this.initSwMessages();
        ebus.$emit('updateInhouseModus');

        this.informPWA();

        let hasFoodData = await this.fastLoadFoods();
        let hasDrinksData = await this.fastLoadDrinks();

        if (initial) {
          // let rn = this.$route.name;
          // if (rn !== 'Home') {
          //   this.gotoHome();
          // }
        }

        if (navigator.onLine) {
          this.loadBaseContext(true); // internally calls initApp

          if (!hasFoodData) {
            await this.pullFoodMenu(0);
          }
          if (!hasDrinksData) {
            await this.pullDrinkMenu(0);
          }
          await this.lazyPullMenus();
        } else {
          this.initApp(initial);
          await this.lazyPullMenus();
        }

        if (appManager.isInstallable()) {
          ebus.$emit('pwaInstallable');
        }

        await this.pullBuyersProfile();

        setTimeout(() => {
          this.loadStores();
        }, 4000);
      } catch (e) {
        console.log('error in init()... ' + e.message);
      }
    },
    av() {
      //init appversion display
      // this.displayAppVersion = 'v' + appVersion;
    },
    transferRedeemedCps() {
      // //transfer redeemed coupons from the localtStore to the backend
      // let cps = this.$ls.get('cpNowQueue', []);
      // if (cps.length === 0) {
      //     return;
      // }
      // console.log('transfer ' + cps.length + ' redeemed coupons');
      // let msg = {
      //     action: qconst.action$TransferCoupons,
      //     coupons: cps
      // };
      // xhr.xhrSend(true, msg, (data) => {
      //     if (data && data.ok) {
      //         this.$ls.remove('cpNowQueue');
      //         console.log('coupon redemptions trasnfered successfully');
      //     }
      // }, (err) => {
      //     // logError('Load orders');
      //     console.log('??? Exception in transferRedeemedCps: ', JSON.stringify(err));
      // });
    },
    jt() {
      util.jumpToTop();
    },
    informPWA() {
      // setTimeout(() => {
      //     if (breakpoints.getCurrentDevice() === 'xs' && !appManager.isStandalone()) {
      //         ebus.$emit('showQuestion', {
      //             quest: 'Bitte installiere unsere PWA auf deinem Home-Screen.',
      //             yesLabel: 'Unsere PWA',
      //             noLabel: 'Später',
      //             yesAction: null,
      //             cb: 'cb-pwa'
      //         });
      //     }
      // }, 2000);
    },
    gotoCategory(cat) {
      // store.state.shouldJump = true;
      this.$router.push({name: 'Speisen', params: {catname: cat}});
      setTimeout(() => {
        util.jumpToTop();
      }, 200);
    },
    gotoHome() {
      this.$router.push({name: 'Home'});
    },
    gotoSortiment() {
      this.$router.push({name: 'Sortiment'});
    },
    // gotoCoupons() {
    //     this.$router.push({name: 'Coupons'});
    // },
    goBack() {
      let rn = this.$route.name;

      // if (this.$store.getters.showDialogContainer) {
      //     setTimeout(() => {
      //         this.$store.commit('showDialogContainer', false);
      //     }, 800);
      //     return;
      // }

      switch (rn) {
        case 'Sortiment':
          this.gotoHome();
          break;
        case 'Aktuelles':
          this.gotoHome();
          break;
        case 'Produkte':
          this.gotoSortiment();
          break;
        // case 'Speise':
        //     this.gotoSortiment();
        //     break;
        default:
          this.$router.go(-1);
          break;
      }
    },
    updateDocTitle(to) {
      try {
        let t = null;
        let routeName = this.$route.name;
        if (to && to.name.length > 1) {
          routeName = to.name;
          try {
            if (routeName === 'Produkte') {
              t = to.params.catname;
            } else if (routeName === 'Speise') {
              let itemId = to.params.itemId;
              let item = store.getters.getFoodById(itemId);
              t = item.nameDE;
            }
          } catch (e) {
            console.log('Error in routeName title: ' + e.message);
          }

          if (!t) {
            if (to.meta && to.meta.title) {
              t = to.meta.title;
            } else {
              t = routeName;
            }
          }

          // if (t) {
          //     t = store.state.brandName + ' - ' + t;
          // }
        } else {
          t = routeName;
        }
        console.log('updateDocTitle: ' + t + ' routeName = ' + this.$route.name);

        // document.title = t || 'App';
        try {
          localStorage.setItem('page_', routeName);
        } catch (e) {

        }
        store.commit('page', '' + (t || 'App'));
      } catch (e) {

      }
    },
    gotoCart() {
      this.$router.push({name: 'Korb'});
    },
    goto(params) {
      let rn = params.name;
      let scrollTarget = params.scrollTarget;
      if (scrollTarget) {
        store.state.scrollTarget = '' + scrollTarget;
      }
      let p = {};
      if (params.params) {
        p = params.params;
      }
      let query = params.query;
      if (query) {
        this.$router.push({name: rn, params: p, query: query});
      } else {
        this.$router.push({name: rn, params: p});
      }
    },
    gotoPage(name) {
      this.$router.push({name: 'Page', params: {name: name}});
    },

    // updateNewsRead(newsRead) {
    //     // console.log('updateNewsRead = ' + JSON.stringify(newsRead));
    //     // let news = store.getters.news;
    //     // let unreadNews = [];
    //     // try {
    //     //     let now = new Date().getTime();
    //     //     for (let n of news) {
    //     //         //display news as unread if they are note older than 1 day or unread
    //     //         if ((now - n.createdAt < (24 * 60 * 60 * 1000)) || !newsRead[n.tag]) {
    //     //             unreadNews.push(n);
    //     //         }
    //     //     }
    //     // } catch (e) {
    //     //     console.log('Error in updateNewsRead: ' + e.message);
    //     // }
    //     // store.commit('unreadNews', unreadNews);
    //     // //     let unreadNews = [];
    //     // //     let newsRead = {};
    //     // //     let lnewsRead = this.$ls.get('newsRead');
    //     // //     if (lnewsRead) {
    //     // //         newsRead = JSON.parse(lnewsRead);
    //     // //     }
    //     // //     for (let n of news) {
    //     // //         if (!newsRead[n.tag]) {
    //     // //             unreadNews.push(n);
    //     // //         }
    //     // //     }
    //     // //     return unreadNews;
    // },

    // logPV() {
    //     // setTimeout(() => {
    //     //     firebaseUtil.logPageView(document.title);
    //     // }, 600);//must run after document.title has been updated
    // },

    checkDsgvo(force) {
      if (store.getters.isKiosk) {
        return;
      }
      if (!store.getters.inhouse) {
        if (force) {
          this.showDsgvoDialog = true;
        } else {
          let dsgvo = this.$ls.get('dsgvo', {});
          if (util.isEmptyObject(dsgvo)) {
            this.showDsgvoDialog = true;
          }
        }
      }
    },

    finishDsgvo() {
      console.log('finishDsgvo');
      let dsgvo = this.$ls.get('dsgvo', {});
      if (dsgvo.statistics) {
        firebaseUtil.initAnalytics();
      }
    },

    async asyncLoadPages(force) {
      if (qconst.enablePages) {
        if (!force) {
          let now = Date.now();
          let easer = getGlobalValueOrZero('loadEaserPages');
          if (!easer || now - parseInt(easer) > 2 * 60 * 1000) {
            setGlobalKeyValue('loadEaserPages', now);
          } else {
            //eased
            return;
          }
        }

        let msg = {
          action: qconst.action$LoadPages,
          dummy: true,
        };
        xhr.xhrSend(true, msg, (data) => {
          if (data && data.ok && data.pages) {
            store.commit('pages', data.pages);
            ebus.$emit('pagesUpdated');
            // this.updateNewsRead(this.$ls.get('newsRead', {}));
          }
        }, (err) => {
          // logError('Load orders');
          console.log('??? Exception in asyncLoadPages: ', JSON.stringify(err));
        });
      }
    },


    // gotoProducts() {
    //     this.$router.push({name: 'SpeisenProdukte', params: {catname: 'all'}});
    // },

    safe(uri) {
      //url save
      return encodeURIComponent(uri);
    },

    // handleScroll(event) {
    //     // console.log('Scroll: ' + (window.scrollY + window.innerHeight) + ' from ' + document.body.clientHeight);
    //     this.scrollPosition = window.scrollY;
    //     if ((window.scrollY + window.innerHeight + 350) >= document.body.offsetHeight) {
    //         this.showScrollDown = false;
    //     } else {
    //         this.showScrollDown = true;
    //         console.log('Scrolling...')
    //     }
    // },
    //
    // scrollDown() {
    //     setTimeout(() => {
    //         try {
    //             window.scrollTo({
    //                 top: window.scrollY + 550,
    //                 left: 0,
    //                 behavior: 'smooth'
    //             });
    //         } catch (e) {
    //             //suck
    //         }
    //     }, 10);
    // },

    gotoStart(withReplace) {
      if (withReplace) {
        this.$router.replace({name: 'Home'});
      } else {
        this.$router.push({name: 'Home'});
      }
      // setTimeout(() => {
      //     util.jumpToTop()
      // }, 140);
    },

    loadBaseContext(initialLoad) {
      console.log('focus: loadBaseContext... NOT');
      // console.log('focus: loadBaseContext...');
      // xhr.getBaseContext(appManager.isStandalone(), reply => {
      //     console.log('<<<', reply);
      //     this.$nextTick(() => {
      //         // if (reply.appContext) {
      //         //     store.commit('appContext', reply.appContext);//features
      //         // }
      //         // if (reply.remoteTime) {
      //         store.commit('remoteTime', reply.remoteTime);
      //         util.initTimeDiff(reply.remoteTime);
      //         // }
      //
      //         // store.commit('lastModifiedFoodMenu', reply.lastModifiedFoodMenu);
      //         // store.commit('lastModifiedDrinkMenu', reply.lastModifiedDrinkMenu);
      //
      //         // if (reply.shortUrl) {
      //         //     store.commit('shortUrl', reply.shortUrl);
      //         // }
      //
      //         if (reply.userInfo && reply.userInfo.length > 0) {
      //             ebus.$emit('showInfo', {
      //                 title: reply.userInfo
      //             });
      //         }
      //
      //         // if (reply.stores) {
      //         //     store.commit('stores', reply.stores);
      //         //     // this.updateOpeningHours();
      //         // }
      //
      //         // if (reply.news) {
      //         //     store.commit('news', reply.news);
      //         //     this.updateNewsRead(this.$ls.get('newsRead', {}));
      //         // }
      //
      //         // if (reply.appSettings) {
      //         //     store.commit('appSettings', reply.appSettings);
      //         //     // this.updateOpeningHours();
      //         // }
      //
      //         //TODO reply.dcontext
      //         //Init restaurantData
      //         // store.commit('storeName', reply.storeName);
      //
      //         // try {
      //         //     store.commit('takeawayData', takeawayData);
      //         // } catch (e) {
      //         //     console.log('XXXXXXXXXXXXX in initTakeawayData');
      //         // }


      try {
        this.initApp(initialLoad);
      } catch (e) {
        console.log('XXXXXXXXXXXXX in initApp: ' + e.message, e);
      }

      // try {
      //     this.doRegisterBusRegisterBusListener();
      // } catch (e) {
      //     console.log('XXXXXXXXXXXXX in doRegisterBusListener');
      // }
      // });
      // }, err => {
      //     console.log('error', 'Error connection to app failed', 'Try to login again ' + err.message);
      //     // this.fastLoadFoods();
      //     // window.location.replace(sse.hardExit);
      //     // this.info('Error: ' + 'Einige Inhalte konnten wege einer Unterbrechung nicht geladen werden. Bitte laden Sie die App neu');
      //
      //     //retry
      //     setTimeout(() => {
      //         if (!store.state.appLoaded) {
      //             this.init();
      // }
      //     }, 30 * 1000);
      //
      //     // let storeid = this.$ls.get(bootstrap.slug);
      //     // if (storeid) {
      //     //     this.initapp(storeid);
      //     //     this.doregisterbuslistener(storeid);
      //     // }
      //
      // });
    },

    // initNextThreeDays(day1Key, day2Key, day3Key) {
    //     if (store.getters.appconfig.takeAway.openingHours[day1Key]) {
    //         store.commit('day1', util.cloneMe(store.getters.appconfig.takeAway.openingHours[day1Key]));
    //         // openingHours.day1.opened = true;
    //     }
    //     if (store.getters.appconfig.takeAway.openingHours[day2Key]) {
    //         store.commit('day2', util.cloneMe(store.getters.appconfig.takeAway.openingHours[day2Key]));
    //         // openingHours.day1.opened = true;
    //     }
    //     if (store.getters.appconfig.takeAway.openingHours[day3Key]) {
    //         store.commit('day3', util.cloneMe(store.getters.appconfig.takeAway.openingHours[day3Key]));
    //         // openingHours.day1.opened = true;
    //     }
    // },

    initSwUpdateInterval(cb) {
      console.log('reload: initSwUpdateInteval...');
      // this.$ls.set('lastPwaUpdate', '' + new Date().getTime());
      this.swUpdateInterval = setInterval(() => {

        this.loadAppconfig();

        // setTimeout(() => {
        this.checkForSwUpdate();
        // this.setLastPwaUpdate();
        // }, 100);//??? ensure that lastPwaUpdateInterval is initialized
        // console.log('??? Execute lastPwaUpdateInterval');

        // }, 30 * 1000);
      }, 4 * 55 * 1000);//check every 3 minutes
      this.checkForSwUpdate(true, cb);
    },

    shareApp() {
      if (!this.$store.getters.inhouse) {
        this.shareDialog = true;
      }
    },

    // waitForInstallPromo() {
    //     if (this.showPromo || this.infoDialog) {
    //         setTimeout(() => {
    //             this.waitForInstallPromo();
    //         }, 2000);
    //     } else {
    //         if (!store.state.pwaInstalled) {
    //             this.showInstallPromo = true;
    //         }
    //         // if(this.pwaFirstTime){
    //         //     this.pwaFirstTime = false;
    //         //showPwaOverlay
    //         // this.showPwaOverlay = true;
    //         // }
    //     }
    // },

    async pullBuyersProfile(force) {
      if (!force) {
        let now = Date.now();
        let easer = getGlobalValueOrZero('loadEaserBuyersProfile');
        if (!easer || now - parseInt(easer) > 2 * 60 * 1000) {
          setGlobalKeyValue('loadEaserBuyersProfile', now);
        } else {
          //eased
          return;
        }
      }

      let msg = {
        action: qconst.action$LoadDocs,
        collectionName: 'gpPaymentMethods',
        query: {
          deviceId: getBtaste(),
        }
        // {'$or': orClauses}
      };
      await xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok && data.docs && Array.isArray(data.docs)) {
          let docs = data.docs;
          console.log('number of gpPaymentMethods by deviceId: ' + docs.length);
          store.commit('paymentMethods', docs);
        } else {
          console.log('error loading gpPaymentMethods');
        }
      });
    },

    initLongTermReload() {
      console.log('reload: initLongTermReload...');
      this.checkAppReload();
      // this.lastPwaUpdateInterval = setInterval(() => {
      //     this.checkAppReload();
      // }, 2 * 66 * 1000);//check every 2 minutes
    },

    checkAppReload() {
      // console.log('reload: checkAppReload');
      // let lastPwaUpdate = this.$ls.get('lastPwaUpdate');
      // if (lastPwaUpdate) {
      //     let lu = parseFloat(lastPwaUpdate);
      //     let appInactive = new Date().getTime() - lu;
      //     // if (appInactive > 1 * 60 * 1000) {//30 minutes
      //     if (appInactive > 20 * 60 * 1000) {//20 minutes
      //         console.log('reload: APP OLDER THAN 20 minutes; RELOAD NOW');
      //         this.setLastPwaUpdate();
      //         // setTimeout(() => {
      //         //     // alert('App older than 20 minutes... reload now');
      //         //     this.init();
      //         //     // location.reload();
      //         // }, 8 * 1000);
      //         // } else if (appInactive > 30 * 60 * 1000) {//30 minutes
      //         //     this.setLastPwaUpdate();
      //         //     this.init();
      //     } else {
      //         console.log('reload: not OLDER THAN 20 minutes');
      //         this.setLastPwaUpdate();
      //     }
      // } else {
      //     this.setLastPwaUpdate();
      // }
    },

    toast(text, time) {
      this.snackText = text;
      if (time) {
        try {
          this.snackTime = parseFloat(time);
        } catch (e) {

        }
      } else {
        this.snackTime = 2000;
      }
      this.showSnackbar = true;
    },

    info(text) {
      this.sheetText = text;
      this.showSheet = true;
      setTimeout(() => {
        this.showSheet = false;
      }, 4000);
    },

    suggestQrCodeScan() {
      ebus.$emit('showInfo', {
        title: 'Bitte scanne zuerst einen QR-Code auf dem Tisch!',
        text: 'Dadurch erfahren wir, an welchem Tisch du sitzt.'
      });
    },

    doConfirmAllReady(table) {
      let msg = {
        action: qconst.action$ConfirmAllReady,
        table: table//string
      };
      // let u = firebaseUtil.getUser();
      // if (u) {
      //     msg.fuid = u.uid;
      // }

      xhr.xhrSend(true, msg, (reply) => {
        if (reply.ok) {
          ebus.$emit('allReadyUpdated');
          setTimeout(() => {
            ebus.$emit('showInfo', {
              title: 'Die Nachricht "WIR SIND FERTIG" ist angekommen.',
              text: 'Vielen Dank!'
            });
          }, 600);
        } else {
          //retry
          setTimeout(() => {
            this.doConfirmAllReady(table);
          }, 2000)
        }
      }, (err) => {
      });
    },

    clickPwaOverlay() {
      this.showInstallPromo = false;
      // this.showPwaOverlay = false;
      ebus.$emit('userWantsToInstall');
    },

    userWantsToInstall() {
      // this.installDialog = false;
      // console.log('??? openInstallPrompt now');
      // if (!this.$store.getters.inhouse) {
      appManager.showInstallPrompt();
      // }
    },

    tryPwaTrigger() {
      if (!this.$store.getters.inhouse && appManager.isInstallable() && !store.state.pwaInstalled) {
        ebus.$emit('installPrompt');
      }
    },

    // lazyShowInviteFriends() {
    //     let usage = this.$ls.get('appUsage', 0);
    //     //only once every 3 days
    //     let timeSince = Date.now() - this.$ls.get('lastIvtFriends', 0);
    //     if (!navigator.onLine
    //         || usage < (50 * 1000)
    //         //mostly every 1 hour
    //         || timeSince < (1 * 60 * 60 * 1000)
    //         || this.isAnyOverlay() || this.isCritical()) {
    //         //retry after 30 seconds
    //         setTimeout(() => {
    //             this.lazyShowInviteFriends();
    //         }, 30 * 1000);
    //         return;
    //     }
    //
    //     this.$ls.set('lastIvtFriends', Date.now());
    //
    //     //Einladung an Freunde
    //     ebus.$emit('showQuestion', {
    //         quest: 'Laden Sie Ihre Freunde ein und sichern sich 3 exklusive Geschenke!',
    //         yesAction: null,
    //         qtext: '<p>Mit nur einem Klick können Sie Ihre Freunde einladen über WhatsApp, Twitter & Co. ' +
    //             'Als Belohnung erhalten Sie nacheinander 3 Coupons als ?:</p></p>' +
    //             '<ul>' +
    //             '<li>1 Kaffegetränk nach Wahl ab 5 Freunde</li>' +
    //             '<li>1 Kuchenstück nach Wahl ab 10 Freunde</li>' +
    //             '<li>1 Grillpaket (Pierre, Langer Hannes, Olivenseelen, Black Tiger) ' +
    //             'ab 15 Freunde</li>' +
    //             '</ul>',
    //         yesLabel: 'Freunde einladen',
    //         cb: 'cb-bivtFriends'
    //     });
    // },

    // lazyShowNewCoupons() {
    //     try {
    //         let cps = util.cloneMe(store.getters.coupons);
    //         if (cps.length === 0 || this.isAnyOverlay() || this.isCritical()) {
    //             //retry after 10 seconds
    //             setTimeout(() => {
    //                 this.lazyShowNewCoupons();
    //             }, 10 * 1000);
    //             return;
    //         }
    //
    //         let tmp = couponUtil.filteredCoupons(cps, store.getters.scannedCode,
    //             store.state.user.fuid, bootstrap.getBtaste(), store.getters.selectedStore.filialnummer);
    //         let coupons = tmp.reverse();
    //         let cpInfo = this.$ls.get('cpInfo', []);
    //         let newCoupons = [];
    //         let couponTitles = [];
    //         console.log('lazy coupons length ' + coupons.length);
    //         for (let c of coupons) {
    //             let cNow = couponUtil.getCouponNowRedeemedAt(c.couponCode);
    //             //nicht eingelöst und noch nicht angezeigt
    //             if (!cNow && !cpInfo.includes(c.couponCode)) {
    //                 newCoupons.push(c);
    //                 if (!couponTitles.includes(c.title)) {
    //                     couponTitles.push(c.title);
    //                 }
    //             }
    //         }
    //
    //         if (couponTitles.length > 0) {
    //             let t = 'Es gibt 1 neuer Coupon';
    //             if (couponTitles.length > 1) {
    //                 t = 'Es gibt ' + couponTitles.length + ' neue Coupons';
    //             }
    //
    //             let list = '';
    //             // let codes = [];
    //             for (let nc of newCoupons) {
    //                 // list += '<li>' + nc.title + '</li>';
    //                 cpInfo.push(nc.couponCode);
    //             }
    //             for (let ct of couponTitles) {
    //                 list += '<li>' + ct + '</li>';
    //             }
    //             ebus.$emit('showInfo', {
    //                 title: '?️ ' + t + '!',
    //                 text: '<ul>' + list + '</ul>',
    //                 // image: img,
    //                 next: ''
    //                 //next: 'Coupons'
    //             });
    //             let exp = 1 * 30 * 24 * 60 * 60 * 1000;//expiry 1 Months
    //             this.$ls.set('cpInfo', cpInfo, exp);
    //         }
    //     } catch (e) {
    //         console.log('Error showing new coupons: ' + e.message);
    //     }
    // },

    // updateInhouseModus() {
    //     // store.commit('inhouse', this.$store.getters.inhouse);
    //     // if (!store.state.enableSelfServiceExtras) {
    //     //     try {
    //     //         if (this.$store.getters.inhouse) {
    //     //             //prevent the inhouse PWA to be installed
    //     //
    //     //             // const p = document.getElementById('pwacompat');
    //     //             // console.log('Removing manifest element on inhouse');
    //     //             // p.remove();
    //     //             // console.log('pwacompat element has been removed on inhouse');
    //     //
    //     //             const m = document.querySelector('[rel=manifest]');
    //     //             m.remove();
    //     //             console.log('Manifest element has been removed on inhouse');
    //     //         }
    //     //     } catch (e) {
    //     //         console.log('error in manifest remove: ' + e.messages);
    //     //     }
    //     // }
    // },

    // lazyShowNewCoupons() {
    //     try {
    //
    //         let lastPromoCoupon = this.$ls.get('lastPromoCoupon');
    //         if (lastPromoCoupon && (Date.now() - lastPromoCoupon) < (10 * 60 * 1000)) {
    //             return;
    //         }
    //
    //         let cps = util.cloneMe(store.getters.coupons);
    //         if (cps.length === 0 || this.isAnyOverlay() || this.isCritical()) {
    //             //retry after 10 seconds
    //             setTimeout(() => {
    //                 this.lazyShowNewCoupons();
    //             }, 10 * 1000);
    //             return;
    //         }
    //
    //         let tmp = couponUtil.filteredCoupons(cps, store.getters.scannedCode,
    //             store.state.user.fuid, bootstrap.uid, store.getters.selectedStore.filialnummer);
    //         let coupons = tmp.reverse();
    //         let cpInfo = this.$ls.get('cpInfo', []);
    //         let newCoupons = [];
    //         let couponTitles = [];
    //         console.log('lazy coupons length ' + coupons.length);
    //         for (let c of coupons) {
    //             let cNow = couponUtil.getCouponNowRedeemedAt(c.couponCode);
    //             //nicht eingelöst und noch nicht angezeigt
    //             if (!cNow && !cpInfo.includes(c.couponCode)) {
    //                 newCoupons.push(c);
    //                 if (!couponTitles.includes(c.title)) {
    //                     couponTitles.push(c.title);
    //                 }
    //             }
    //         }
    //
    //         if (couponTitles.length > 0) {
    //             let t = '🌟 Es gibt einen neuen Coupon';
    //             if (couponTitles.length > 1) {
    //                 t = '🌟 Es gibt ' + couponTitles.length + ' neue Coupons';
    //             }
    //
    //             // let list = '';
    //             // // let codes = [];
    //             // for (let nc of newCoupons) {
    //             //     // list += '<li>' + nc.title + '</li>';
    //             //     cpInfo.push(nc.couponCode);
    //             // }
    //             // for (let ct of couponTitles) {
    //             //     list += '<li>' + ct + '</li>';
    //             // }
    //
    //
    //             ebus.$emit('showQuestion', {
    //                 quest: t,
    //                 text: '',
    //                 // text: '<ul>' + list + '</ul>',
    //                 yesLabel: 'Coupons anschauen',
    //                 noLabel: 'Danke, später',
    //                 // yesAction: null,
    //                 cb: 'cb-jumpToCoupons'
    //             });
    //
    //             this.$ls.set('lastPromoCoupon', Date.now());
    //
    //             // ebus.$emit('showInfo', {
    //             //     title: '' + t + '',
    //             //     text: '<ul>' + list + '</ul>',
    //             //     // image: img,
    //             //     next: ''
    //             //     //next: 'Coupons'
    //             // });
    //             let exp = 1 * 30 * 24 * 60 * 60 * 1000;//expiry 1 Months
    //             this.$ls.set('cpInfo', cpInfo, exp);
    //         }
    //     } catch (e) {
    //         console.log('Error showing new coupons: ' + e.message);
    //     }
    // },

    appFocused() {
      console.log('appFocused');
      store.commit('showLoading', false);

      ebus.$emit('appFocused');

      this.initSwMessages();

      ebus.$emit('updateInhouseModus');

      // this.restoreCartItems();

      //custom
      // console.log('isInhouse = '+store.getters.inhouse);
      this.lazyShowWelcome();

      this.loadAppconfig();

      //only for iframe
      // iframe.post_startRender();

      this.informPWA();

      // ebus.$emit('appFocused');
      setTimeout(() => {
        this.appUsage = Date.now();
        // let rNow = util.getCurrentRemoteTime();
        // let currentDay = util.getDayOfWeek(rNow);
        // console.log('focus: currentDay = ' + currentDay);
        // let _cDay = this.$ls.get('cDay');
        // let completeInit = false;
        // this.$ls.set('cDay', currentDay);
        // if (_cDay) {
        //     let cDay = parseFloat(_cDay);
        //     completeInit = cDay !== currentDay;
        //     if (completeInit) {
        //         this.loadBaseContext(false);
        //     }
        // }


        this.initSwUpdateInterval(allowedToReload => {
          // console.log('allowedToReload = '+allowedToReload);
          // if (allowedToReload) {
          this.initLongTermReload();
          // }
        });

        // console.log('focus: completeInit = ' + completeInit);

        // if (!completeInit) {
        this.doRegisterBusListener();
        // let storeId = this.$ls.get(bootstrap.slug);
        // if (storeId) {
        //     this.doRegisterBusListener(storeId);
        // }

        setTimeout(() => {
          // if (store.getters.foodMenu.length === 0) {
          this.fastLoadFoods();
          this.fastLoadDrinks();
          // let storeId = this.$ls.get(bootstrap.slug);
          // if (storeId) {
          //     // this.fastLoadDrinks(storeId);
          //     this.fastLoadFoods(storeId);
          // }
          // }
          this.lazyPullMenus();
        }, 2000); //time for swUpdate to check
        // }

        this.checkDsgvo();
        let delay = 1;
        if (!this.showDsgvoDialog) {
          this.finishDsgvo();
        } else {
          delay = 2000;
        }

        // setTimeout(() => {
        //     this.lazyShowNewCoupons();
        //     // this.lazyShowInviteFriends();
        // }, delay);

      }, 1000);//wait for the component scope to initialize

    },

    getTotalAppUsage() {
      let time = Date.now() - this.appUsage;
      let lsTime = this.$ls.get('appUsage', 0);
      return time + lsTime;
    },

    appLostfocus() {
      try {
        console.log('appLostfocus');

        //update total appUsage in localStorage
        // let time = Date.now() - this.appUsage;
        // let lsTime = this.$ls.get('appUsage', 0);
        let tau = this.getTotalAppUsage();
        console.log('Total appUsage in seconds = ' + (tau / 1000));
        let exp = 2 * 30 * 24 * 60 * 60 * 1000;//expiry 2 Months
        this.$ls.set('appUsage', tau, exp);

        if (this.lastPwaUpdateInterval) {
          util.clearTheInterval(this.lastPwaUpdateInterval);
          this.lastPwaUpdateInterval = null;
        }
        if (this.swUpdateInterval) {
          this.clearSwInterval();
        }
      } catch (e) {
        console.log('Error in appLostfocus ', e);
      }
      sse.closeSSE(true);
    },

    async fastLoadDrinks() {
      await getCachedValue('drinks', drinksInStore => {
        if (drinksInStore) {
          drinksInStore = this.filterMenu(drinksInStore);
          console.log('fastLoadDrinks found cached data');
          this.updateDrinksData(drinksInStore);
        }
        return (!!drinksInStore && drinksInStore.length > 0);
      }, []);
    },

    async fastLoadFoods() {
      await getCachedValue('food', foodInStore => {
        if (foodInStore) {
          foodInStore = this.filterMenu(foodInStore);
          console.log('fastLoadFoods found cached data');
          this.updateFoodData(foodInStore);
        }
        return (!!foodInStore && foodInStore.length > 0);
      }, []);
    },

    // initFoodCats() {
    //     let foodCats = util.cloneMe(store.getters.foodMenu);
    //     // console.log('so do we have cats??? ' + foodCats.length);
    //     for (let fcat of foodCats) {
    //         if (!fcat.items) {
    //             continue;
    //         }
    //         // for (let item of fcat.items) {
    //         //     let offerAndItem = store.getters.getOfferByItemId(item.id);
    //         //     // item.offered = !!offerAndItem;
    //         //     // if (!!offerAndItem) {
    //         //     //     item.offerId = offerAndItem.offer.id;
    //         //     // }
    //         //     this.applyOfferAndPrices(item, offerAndItem);
    //         // }
    //     }
    //     this.foodCategories = foodCats;
    // },

    openCouponInfo(coupon) {
      if (coupon) {
        this.currentCoupon = coupon;
        this.showPromo = true;
        navigationState.setPromoDialog(true);
      }
    },

    mailFeedback(asMessage) {
      // let start = 'Feedback zur App ';
      // if (asMessage) {
      let start = 'Nachricht an ';
      // }
      let sb = encodeURIComponent(start + store.getters.storeName);
      let mailto_link = 'mailto:support@qsignal.de?subject=' + sb;
      let win = window.open(mailto_link);//, '_blank');
      win.focus();
    },

    isAnyOverlay() {
      return false;
      // return document.getElementsByClassName('v-overlay--active').length > 0;
    },

    loadSelectedStore() {
      //restore selectedStore
      let lsSelectedStore = this.$ls.get('selectedStore', false);
      if (lsSelectedStore && lsSelectedStore.strasse && lsSelectedStore.filialnummer) {
        // let str = store.getters.getStoreByFi(lsSelectedStore.filialnummer);
        store.commit('selectedStore', lsSelectedStore);
      }
    },

    initApp(initialLoad) {
      console.log('initApp...');
      // storageUtil.requestStorage();
      if (this.duringInit) {
        this.duringInit = true;
        console.log('prevented double initApp');
        setTimeout(() => {
          this.duringInit = false;
        }, 2200);
        return;
      }

      ebus.$emit('updateInhouseModus');

      //restore cartItems
      // this.restoreCartItems();

      if (initialLoad) {
        //restore selectedStore
        // let lsSelectedStore = this.$ls.get('selectedStore');
        // if (lsSelectedStore) {
        //     let lss = JSON.parse(lsSelectedStore);
        //     store.commit('selectedStore', lss);
        // }
      }

      // (query) was moved to UseCaseLifecycle

      //initial route
      // this.$router.push({name: 'takeAway'});

      // this.fastLoadDrinks();
      // this.fastLoadFoods();
      // this.lazyPullMenus();

      this.combineFavs();

      this.loadAppconfig();

      setTimeout(() => {
        this.loadLastOrders(true);
      }, 2200);

      // if (bootstrap.hasAccount()) {
      //     //note: userSignedIn triggers loadCoupons()
      //     setTimeout(() => {
      //         //     this.loadCoupons(restId);
      //         if (store.getters.scannedCode.length > 0 && !store.getters.loggedIn) {
      //             ebus.$emit('showInfo', {
      //                 title: 'Bitte melde dich an, um deine Coupons zu erhalten'
      //             });
      //         }
      //     }, 7000);//give firebase a little time to signIn, otherwise referralprograms are missing
      // } else {
      // this.loadCoupons();
      // }
      // this.loadCoupons(restId);

      // this.initPromoInterval();

      setTimeout(() => {
        this.asyncLoadPages();
      }, 800);
      setTimeout(() => {
        if (qconst.preloadCoupons) {
          this.loadCoupons(false);
        }
        this.loadOffers();
      }, 1400);

      setTimeout(() => {
        this.transferRedeemedCps();
        //     this.loadOffers();
      }, 8000);

      //preload animation
      // fetch('/animMiverrup.json')
      //     .then(response => response.json())
      //     .then(data => console.log('loaded animation::::: ' + data));
      // // .then(response => response.json())
      // // .then(data => console.log(data));

      store.commit('appLoaded', true);
      ebus.$emit(qconst.notify$appLoaded);
    },

    lazyShowWelcome() {
      // if (this.isInApp) {
      //   return;
      // }
      // if (store.getters.inhouse) {
      //   let lv = this.$ls.get('lastVisit', 0);
      //   let now = Date.now();
      //   if (now - lv > (1 * 60 * 60 * 1000)) { //2H
      //     this.$ls.set('lastVisit', now);
      //
      //     ebus.$emit('showInfo', {
      //       title: 'Herzlich Willkommen bei ' + store.state.brandName,
      //       text: 'Bestelle dein Essen und deine Getränke, wir bringen sie zu deinem Tisch.<br><br>' +
      //         'Möchtest du bezahlen, dann rufe den Kellner über die Kellnerruf-Funktion der App.<br><br>' +
      //         // 'Hier kannst du bequem dein Essen und deine Getränke online bestellen und bezahlen. ' +
      //         // 'Wir bereiten dein Gericht frisch für dich zu und bringen es dir dann zum Tisch.<br><br>' +
      //         'Genieße deinen Aufenthalt!'
      //     });
      //   }
      // } else {
      //   let lv = this.$ls.get('lastVisit', 0);
      //   let now = Date.now();
      //   if (now - lv > (2 * 30 * 24 * 60 * 60 * 1000)) { //2 Monate
      //     this.$ls.set('lastVisit', now);
      //
      //     ebus.$emit('showInfo', {
      //       title: 'Herzlich Willkommen bei ' + store.state.brandName,
      //       text:
      //         'Hier kannst du dein Essen zum Abholen bequem vorbestellen und online bezahlen per ' +
      //         'PayPal, Apple Pay, Google Pay oder Kreditkarte. <br><br>' +
      //         'Danke, dass du unseren Service nutzt!'
      //     });
      //   }
      // }
    },

    async loadStores(params) {
      // let msg = {
      //     action: qconst.action$LoadStores,
      // };
      //
      // xhr.xhrSend(true, msg, (reply) => {
      //     if (reply.ok && reply.stores) {
      //         store.commit('stores', reply.stores);
      //         this.loadSelectedStore();
      //     } else {
      //         //retry
      //         setTimeout(() => {
      //             this.loadStores();
      //         }, 9000)
      //     }
      // }, (err) => {
      //     console.log('??? error loadStores: ' + JSON.stringify(err));
      //     //retry
      //     setTimeout(() => {
      //         this.loadStores();
      //     }, 2000)
      // });
    },

    async loadAppconfig() {
      //prevent double load
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadEaserAppConfig');
      if (!easer || now - parseInt(easer) > 1 * 60 * 1000) {
        setGlobalKeyValue('loadEaserAppConfig', now);
      } else {
        //eased
        return;
      }

      let msg = {
        action: qconst.action$GetAppconfig,
      };
      // let u = firebaseUtil.getUser();
      // if (u) {
      //     msg.fuid = u.uid;
      // }

      await xhr.xhrSend(true, msg, (reply) => {
        if (reply.ok && reply.appconfig) {
          let appconfig = reply.appconfig;
          //add missing props
          if (appconfig.takeAway) {
            if (!(appconfig?.takeAway?.delayInMinutes)) {
              appconfig.takeAway.delayInMinutes = 0;
            }
            if (!(appconfig?.takeAway?.minOrderAmount)) {
              appconfig.takeAway.minOrderAmount = 0;
            }
          }
          if (appconfig.delivery) {
            if (!(appconfig?.delivery?.deliveryFee)) {
              appconfig.delivery.deliveryFee = 0;
            }
            if (!(appconfig?.delivery?.delayInMinutes)) {
              appconfig.delivery.delayInMinutes = 0;
            }
            if (!(appconfig?.delivery?.minOrderAmount)) {
              appconfig.delivery.minOrderAmount = 0;
            }
          }
          let newAppconfig = util.cloneMe(appconfig);
          let existingConfig1 = util.cloneMe(store.getters.appconfig);
          let existingConfig2 = util.cloneMe(store.getters.appconfig);

          // check if there would be a change if we would update appConfig
          let eq = false;
          //For non-franchise
          Object.assign(existingConfig2, appconfig);
          eq = util.mapEquals(existingConfig1, existingConfig2);
          //For franchise
          // if (store.getters.isStoreSelected) {
          //   let selectedStore = store.getters.selectedStore;
          //   Object.assign(existingConfig2, newAppconfig);
          //   Object.assign(existingConfig2, storesUtil.getAppConfigUpdate(selectedStore));
          //   eq = util.mapEquals(existingConfig1, existingConfig2);
          // }

          if (eq) {
            console.log('appconfig is equal');
          } else {
            console.log('appconfig has been updated');
            // console.log('appconfig ' + JSON.stringify(reply.appconfig));
            store.commit('appconfig', existingConfig2);
            ebus.$emit('appconfigLoaded');

            let uinfo = store.getters.appconfig.userInfo;
            if (uinfo) {
              ebus.$emit('showInfo', {
                title: '' + uinfo,
                text: ''
              });
            }

            //filter menu for display
            // this.filterGlobalExtras(store.getters.foodMenu);
            // this.filterGlobalExtras(store.getters.drinkMenu);

          }
        } else {
          //retry
          setTimeout(() => {
            this.loadAppconfig();
          }, 2000)
        }
      }, (err) => {
        console.log('??? error loading appconfig: ' + JSON.stringify(err));
        //retry
        setTimeout(() => {
          this.loadAppconfig();
        }, 2000)
      });
    },

    async loadLastOrders(initial, params) {
      //prevent double load
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadEaserLoadOrders');
      if (!easer || now - parseInt(easer) > 5 * 1000) {
        setGlobalKeyValue('loadEaserLoadOrders', now);
      } else {
        //eased
        return;
      }

      //first load the lastOrder
      let lorders = [];
      let lastOrder = this.$ls.get('lastOrder', false);
      if (lastOrder) {
        lorders.push(lastOrder);
      }

      // if (navigator.onLine) {
      console.log('??? load last orders....');
      let msg = {
        action: qconst.action$GetLastSelfOrders,
      };
      if (params && params.uniqueOrderId) {
        msg.uniqueOrderId = params.uniqueOrderId;
      }
      // let u = firebaseUtil.getUser();
      // if (u) {
      //     msg.fuid = u.uid;
      // }

      await xhr.xhrSend(true, msg, (reply) => {
        // console.log('respnose of loadLastOrders ok = ' + reply.ok);
        if (reply.ok && reply.orders) {
          lorders = reply.orders;
          console.log('finishLOrders found: ' + lorders.length);
          this.finishLOrders(lorders);
          if (initial) {
            this.considerDefaultView();
          }
        }
      }, (err) => {
        console.log('??? error loading last orders: ' + JSON.stringify(err));
      });
      // } else {
      //   this.finishLOrders(lorders);
      // }
    },

    finishLOrders(lorders) {
      store.commit('lastOrders', lorders);
      ebus.$emit('lastOrdersUpdated');
    },

    // initPromoInterval() {
    //     // this.lazyShowInvitationHint();
    //     if (this.promoInterval === null) {
    //         this.promoInterval = setInterval(() => {
    //             this.lazyShowPromos();
    //             if (!this.flagIgnoreInterval) {
    //                 setTimeout(() => {
    //                     this.showReferralHint();
    //                 }, 60 * 1000);
    //             }
    //             this.flagIgnoreInterval = !this.flagIgnoreInterval;
    //             // }, 5 * 1000);
    //             //FIXME
    //         }, 4 * 60 * 1000);
    //     }
    // },

    isCritical() {
      let rName = this.$route.name;
      console.log('rName = ' + rName);
      return rName.indexOf('checkout') !== -1
        || rName.indexOf('Registrierung') !== -1
        || rName.indexOf('Coupons') !== -1
        || rName.indexOf('Einloesen') !== -1
        || rName.indexOf('Anmelden') !== -1;
    },

    // showbInvitation() {
    //     if (this.$ls.get('blockBivtr', false)) {
    //         console.log('block blockBivtr');
    //         return;
    //     }
    //
    //     let bivtr = this.$ls.get('bivtr');
    //     if (bivtr) {
    //         ebus.$emit('showQuestion', {
    //             quest: 'Wir freuen uns Sie in der App-Filiale von THEURER begrüßen zu dürfen ?',
    //             yesAction: null,
    //             qtext: 'Wenn Sie sich online registrieren erhalten Sie einen zusätzlichen Coupon mit <b>10% Rabatt</b> auf den kompletten Einkauf ☕???. ' +
    //                 'Zur Benutzung der Coupons ist keine Registrierung und kein Internet notwendig! ' +
    //                 'Möchten Sie die Einladung Ihres Bekannten/Freundes annehmen?',
    //             yesLabel: 'Einladung annehmen',
    //             cb: 'cb-bvitFollow'
    //         });
    //     }
    // },

    // showInvitation() {
    //     let ivt = this.$ls.get('invitation');
    //     if (ivt) {
    //         let invitation = JSON.parse(ivt);
    //         console.log('??? amountForFriend = ' + invitation.amountForFriend);
    //         console.log('??? amountForFriend parsed = ' + parseInt(invitation.amountForFriend));
    //         let displayAmount = util.getLocalPrice(parseInt(invitation.amountForFriend));
    //
    //         let title = invitation.referrerName + ' hat dich eingeladen: ' +
    //             'Registriere dich jetzt und erhalte eine ' + displayAmount + ' Gutschein für deine erste Bestellung!';
    //
    //         ebus.$emit('showInfo', {
    //             title: title, text: 'Du erhälst den Gutschein im Wert von ' + displayAmount +
    //                 ' sofort nach deiner Registrierung.'
    //         });
    //
    //         //text: 'Den Gutschein im Wert von '+displayAmount+
    //         //' für deine erste Bestellung erhälst du sofort nach deiner Registrierun.'
    //     }
    // },

    // showReferralHint() {
    //     if (store.getters.loggedIn && store.getters.referralPrograms.length > 0) {
    //         this.currentReferralProgram = store.getters.referralPrograms[0];
    //         // this.$nextTick(() => {
    //         this.showReferralProgram = true;
    //         // });
    //     }
    // },

    // lazyShowPromos() {
    //     if (this.isCritical()) {
    //         return;
    //     }
    //
    //
    //     //TODO
    //     // // let ivt = this.$ls.get('invitation');
    //     // // if (ivt) {
    //     // //     let invitation = JSON.parse(ivt);
    //     // //     console.log('??? amountForFriend = ' + invitation.amountForFriend);
    //     // //     console.log('??? amountForFriend parsed = ' + parseInt(invitation.amountForFriend));
    //     // //     let displayAmount = util.getLocalPrice(parseInt(invitation.amountForFriend));
    //     // //
    //     // //     let title = invitation.referrerName + ' hat dich eingeladen: ' +
    //     // //         'Registriere dich jetzt und erhalte einen ' + displayAmount + ' Gutschein für deine erste Bestellung!';
    //     // //
    //     // //     ebus.$emit('showInfo', {
    //     // //         title: title, text: 'Du erhälst den Gutschein im Wert von ' + displayAmount +
    //     // //             ' sofort nach deiner Registrierung.'
    //     // //     });
    //     // //
    //     // //     //text: 'Den Gutschein im Wert von '+displayAmount+
    //     // //     //' für deine erste Bestellung erhälst du sofort nach deiner Registrierun.'
    //     // // } else {
    //     // // }
    //     //
    //     // // this.showReferralHint();
    //     //
    //     // //show the next coupon
    //     // console.log('show the next coupon showPromo = ' + this.showPromo);
    //     // if (!this.showPromo) {
    //     //     setTimeout(() => {
    //     //         if (this.isCritical()) {
    //     //             return;
    //     //         }
    //     //         // let fuid = null;
    //     //         // let u = firebaseUtil.getUser();
    //     //         // if (u) {
    //     //         //     fuid = u.uid;
    //     //         // }
    //     //
    //     //         try {
    //     //             let fc = this.getFilteredCoupons();
    //     //             console.log('filteredCouponsPromo = ', fc);
    //     //             if (fc.length > 0) {
    //     //                 let randomIndex = util.randomInt(0, fc.length - 1);
    //     //                 // this.currentCoupon = fc[randomIndex];
    //     //                 // // this.$nextTick(() => {
    //     //                 // this.showPromo = true;
    //     //
    //     //                 //don't show coupon already in cart
    //     //                 let show = true;
    //     //                 let coupon = fc[randomIndex];
    //     //                 for (let itm of store.getters.cartItems) {
    //     //                     if (itm.couponCode === coupon.couponCode) {
    //     //                         console.log('prevent promo of coupon already in cart');
    //     //                         show = false;
    //     //                         break;
    //     //                     }
    //     //                     let redeemedNowAt = couponUtil.getCouponNowRedeemedAt(itm.couponCode);
    //     //                     if(redeemedNowAt){
    //     //                         console.log('prevent promo of coupon already couponNow');
    //     //                         show = false;
    //     //                         break;
    //     //                     }
    //     //                 }
    //     //                 if (show) {
    //     //                     this.openCouponInfo(coupon);
    //     //                 }
    //     //                 // });
    //     //             } else {
    //     //                 console.log('show promotions/offers...');
    //     //                 let promos = store.getters.offerPromotions;
    //     //                 if (promos.length > 0) {
    //     //                     let randomIndex = util.randomInt(0, promos.length - 1);
    //     //                     // console.log('randomIndex ==== ' + randomIndex);
    //     //                     this.currentOfferId = promos[randomIndex].id;
    //     //                     // console.log('currentOfferId ==== ' + this.currentOfferId);
    //     //                     // this.$nextTick(() => {
    //     //                     this.offerInfoDialog = true;
    //     //                     navigationState.setPromoDialog(true);
    //     //                     // });
    //     //                 }
    //     //             }
    //     //         } catch (e) {
    //     //             console.log('!!!!! error in lazyShowPromos: ', e);
    //     //         }
    //     //     }, 1500);
    //     // }
    // },


    // closeOfferInfoDialog() {
    //     this.offerInfoDialog = false;
    //     navigationState.setPromoDialog(false);
    // },

    closeCouponInfoDialog() {
      this.showPromo = false;
      navigationState.setPromoDialog(false);
    },

    // getFilteredCoupons() {
    //     let fuid = null;
    //     let u = firebaseUtil.getUser();
    //     if (u) {
    //         fuid = u.uid;
    //     }
    //     return couponUtil.filteredCoupons(store.getters.coupons, store.getters.scannedCode, fuid, store.getters.selectedStore.filialnummer);
    // },

    // lazyAddScannedCode(code) {
    //     let sc = this.$ls.get('scannedCodes');
    //     if (sc) {
    //         let codes = JSON.parse(sc);//array of strings
    //         if (!codes.includes(code)) {
    //             codes.push(code);
    //             this.$ls.set('scannedCodes', JSON.stringify(codes));
    //             console.log('code added to existing array');
    //             return true;
    //         }
    //     } else {
    //         this.$ls.set('scannedCodes', JSON.stringify([code]));
    //         console.log('code added to new array');
    //         return true;
    //     }
    //     console.log('code already added to array');
    //     return false;
    // },

    loadOffers() {
      // if (qconst.enableOffers) {
      //     if (!navigator.onLine) {
      //         return;
      //     }
      //
      //     let msg = {
      //         action: qconst.action$LoadOffers
      //     };
      //     xhr.xhrSend(true, msg, (data) => {
      //         if (data && data.ok && 'offers' in data) {
      //
      //             store.commit('offers', data.offers);
      //
      //             console.log('??? offers: ', data.offers);
      //
      //             console.log('??? data promotions: ', data.offerPromotions);
      //
      //             if (data.offerPromotions) {
      //                 store.commit('offerPromotions', data.offerPromotions);
      //             }
      //
      //             ebus.$emit('offersUpdated');
      //
      //         } else {
      //             console.log('??? Error loading offers');
      //         }
      //     }, (err) => {
      //         // logError('Load orders');
      //         console.log('??? Exception in loadOffers: ', JSON.stringify(err));
      //     });
      // }
    },

    triggerSearchAnywhere() {
      //     let rName = this.$route.name;
      //     console.log('search on route name = ' + rName);
      //
      //     // let rp = this.$route.path;
      //     // console.log('search on route path = ' + rp);
      //
      //     if (rName !== 'search') {
      //         this.$router.push({name: 'Suche'});
      //         setTimeout(() => {
      //             ebus.$emit('triggerMenuSearch');
      //         }, 700);
      //     } else {
      //         ebus.$emit('triggerMenuSearch');
      //     }
    },

    openGooglePay() {
      let win = window.open('https://pay.google.com/intl/de_de/about/learn/', '_blank');
      win.focus();
    },

    openApplePay() {
      // https://www.apple.com/apple-card/
      let win = window.open('https://support.apple.com/de-de/HT204506', '_blank');
      win.focus();
    },

    // updateRelevantArea() {
    //     let da = JSON.parse(this.$ls.get('deliveryAddress'));
    //     let found = false;
    //     if (da && da.plz) {
    //         for (let area of store.getters.appconfig.deliveryAreas) {
    //             if (area.plz === da.plz) {
    //                 store.commit('relevantArea', area);
    //                 found = true;
    //                 this.acceptInvitation(da.plz);
    //                 break;
    //             }
    //         }
    //     }
    //     if (!found) {
    //         store.commit('relevantArea', {
    //             minOrderAmount: 0,
    //             fee: 0
    //         });
    //     }
    // },

    // setLastScannedCode() {
    //     console.log('scannedCodes check in localStorage....');
    //     let sc = this.$ls.get('scannedCodes');
    //     if (sc) {
    //         let codes = JSON.parse(sc);//array of strings
    //         if (codes.length > 0) {
    //             console.log('scannedCodes exists');
    //             //get tha last scanned code
    //             let code = codes[codes.length - 1];
    //             store.commit('scannedCode', code);
    //             console.log('scannedCode set to ' + code);
    //         }
    //     }
    // },

    acceptInvitation(plz) {
      // let ivt = this.$ls.get('invitation');
      // if (!ivt) {
      //     return;
      // }
      //
      // //TODO
      // // let ok = false;
      // // for (let da of store.getters.appconfig.deliveryAreas) {
      // //     if (da.plz === plz) {
      // //         ok = true;
      // //     }
      // // }
      // //
      // // if (!ok) {
      // //     console.log('Invitation not successfull because of wrong PLZ');
      // //     this.$ls.remove('invitation');
      // //     return;
      // // }
      //
      // let invitation = JSON.parse(ivt);
      // let msg = {
      //     // restId: store.getters.restId,
      //     action: qconst.action$AcceptInvitation,
      //     referrer: invitation.referrer,//referrer fuid
      //     ruid: invitation.ruid,//referrer uid
      //     rpId: invitation.rpId,//referralProgramId
      //     friend: firebaseUtil.getUser().uid,
      //     referrerName: invitation.referrerName,
      //     friendName: firebaseUtil.getUser().displayName,
      //     plz: plz
      // };
      // xhr.xhrSend(true, msg, (data) => {
      //     if (data && data.ok) {
      //         console.log('lastPwaUpdate: invitation process finished');
      //         this.$ls.remove('invitation');
      //         store.commit('coupons', []);
      //         // ebus.$emit('reload', true);
      //
      //         //reload coupons to fetch the individual reward
      //         this.loadCoupons();
      //     } else {
      //         console.log('??? Response of acceptInvitation is not ok');
      //     }
      // }, (err) => {
      //     // logError('Load orders');
      //     console.log('??? Exception in acceptInvitation: ', JSON.stringify(err));
      // });
    },

    updateCouponsInStore(coupons, fuid) {
      if (coupons) {
        //unfiltered in store but filtered for presentation
        store.commit('coupons', coupons);
      }

      this.removeCouponsAlreadyRedeemed(fuid);
      this.filterIcoupons(fuid, true);

      console.log('coupons after filtering: : ', util.cloneMe(store.getters.coupons));
      this.$ls.set('coupons', JSON.stringify(coupons));

      ebus.$emit('couponsUpdated');
    },

    async loadCoupons(force) {
      if (store.state.enableCoupons) {
        if (store.getters.coupons.length === 0 || force) {
          //fast load coupons for offline capability
          let c = this.$ls.get('coupons');
          if (c) {
            let cpons = c;
            this.updateCouponsInStore(cpons);
          }
        }

        // if (!navigator.onLine) {
        //     return;
        // }

        let msg = {
          action: qconst.action$LoadCoupons
        };
        let user = firebaseUtil.getUser();
        if (user) {
          msg.fuid = user.uid;
        }
        console.log('??? loadCoupons... with fuid: ' + msg.fuid);
        xhr.xhrSend(true, msg, (data) => {
          if (data && data.ok) {

            console.log('<<< coupons: ', data);

            if ('referralPrograms' in data) {
              store.commit('referralPrograms', data.referralPrograms);
              console.log('number of referral programs: ' + data.referralPrograms.length);
              // this.showReferralHint();
            }


            //
            if ('coupons' in data) {
              //for ofline capability
              // this.$ls.set('coupons', JSON.stringify(data.coupons));
              this.updateCouponsInStore(data.coupons, msg.fuid);
              //     //unfiltered in store but filtered for presentation
              //     store.commit('coupons', data.coupons);
            }
            // console.log('coupons serverside stored: ', data.coupons);
            //
            // this.removeCouponsAlreadyRedeemed(msg.fuid);
            // this.filterIcoupons(msg.fuid, true);
            //
            // console.log('coupons after filtering: : ', util.cloneMe(store.getters.coupons));

            if (this.initialScannedCouponWarning) {
              this.initialScannedCouponWarning = false;
              console.log('initial initialScannedCouponWarning=true');
              //TODO guitschein wurde bereits eingelöst anzeige bei scanned coupon
              // this.showScannedCouponWarning(false);
            }

            // console.log('??? coupons: ', data.coupons);

            let scannedCoupon = store.getters.getScannedCoupon;

            console.log('coupons scannedCoupon : ', scannedCoupon);

            console.log('coupon: scannedCoupon && (scannedCoupon.validUntil > new Date().getTime()) = ' + (scannedCoupon && (scannedCoupon.validUntil > new Date().getTime())))
            if (scannedCoupon && (scannedCoupon.validUntil > new Date().getTime())) {
              // this.addCouponToBasket(scannedCoupon, true);
              this.lazyShowPromos();
            }

            if (!this.$ls.get('invitation')) {
              setTimeout(() => {
                let u = firebaseUtil.getUser();
                if (u) {
                  this.removeCouponsAlreadyRedeemed(u.uid);
                  this.filterIcoupons(u.uid);

                  for (let c of store.getters.coupons) {
                    if (c.couponCode && c.couponCode.indexOf('ivtReward') !== -1) {
                      // if (this.dontProcessRewardFriend(c)) {
                      //     continue;
                      // }
                      this.addCouponToBasket(c, true);
                      setTimeout(() => {
                        // ebus.$emit('toast', 'Der Gutschein befindet sich in deinem Korb.');
                        ebus.$emit('showInfo', {
                          title: 'Du hast eine Belohnung erhalten!',
                          text: 'Der Coupon befindet sich im Korb.'
                        });
                      }, 800);

                      break;
                    }
                  }
                } else {
                  for (let c of store.getters.coupons) {
                    // if (c.couponCode === 'Neukundenrabatt') {
                    //     this.addCouponToBasket(c, true);
                    //     break;
                    // }
                  }
                }
              }, 2400);//give firebase a bit more time for signin
            }

            ebus.$emit('couponsUpdated');

          } else {
            console.log('??? Error loading coupons');
          }
        }, (err) => {
          // logError('Load orders');
          console.log('??? Exception in loadCoupons: ', JSON.stringify(err));
        });
      }
    },

    addCouponToBasket(c, show) {
      c.isCoupon = true;
      c.count = 1;
      c.cartItemId = util.generateClientId();
      store.commit('addItemToCart', {item: c});
      if (show && !this.showPromo) {
        this.openCouponInfo(c);
      }
    },

    removeCouponsAlreadyRedeemed(fuid) {
      //filter out coupons that have already been redeemed by the fuid
      // console.log('??? removeCouponsAlreadyRedeemed...');
      try {
        for (let coupon of store.getters.coupons) {
          this.checkAndRemoveRedeemed(coupon, fuid);
        }

        for (let itm of store.getters.cartItems) {
          if (itm.couponCode) {
            this.checkAndRemoveRedeemed(itm, fuid);
          }
        }

        // if (this.$ls.get('invitation') || fuid) {
        //     //remove Neukundenrabatt if still existing
        //     for (let itm of store.getters.cartItems) {
        //         if ('couponCode' in itm && itm.couponCode === 'Neukundenrabatt') {
        //             store.commit('deleteCartItem', itm);
        //         }
        //     }
        //     for (let c of store.getters.coupons) {
        //         if (c.couponCode === 'Neukundenrabatt') {
        //             store.commit('deleteCouponByCode', c.couponCode);
        //         }
        //     }
        // }
      } catch (e) {
        console.log('Error in removeCouponsAlreadyRedeemed: ', e);
      }

    },

    checkAndRemoveRedeemed(coupon, fuid) {
      //filter couponNow which have been redeemed for more than 3 hours ago
      let redeemedNowAt = couponUtil.getCouponNowRedeemedAt(coupon.couponCode);
      // console.log('redeemedNowAt = '+redeemedNowAt);
      if (redeemedNowAt) {
        if (Date.now() - redeemedNowAt > (3 * 60 * 60 * 1000)) {
          store.commit('deleteCouponByCode', coupon.couponCode);
          return;
        }
      }

      // if (!fuid) {
      //     return;
      // }

      let isRedeemed = couponUtil.isCouponRedeemed(store.getters.getCouponByCode(coupon.couponCode), fuid)
      if (isRedeemed) {
        //already redeemed, so lets remove it
        console.log('??? remove coupon code already redeemed: ' + coupon.couponCode);
        store.commit('deleteCouponByCode', coupon.couponCode);
        console.log('deleteCartItem 3');
        store.commit('deleteCartItem', coupon);
      }
    },

    filterIcoupons(fuid, noEvent) {
      if (fuid) {
        //hide individual coupons or filter them by fuid
        for (let coupon of store.getters.coupons) {
          if (coupon.type === 'individual') {
            // if(coupon.fuid){
            if ((coupon.fuid && coupon.fuid !== fuid) || coupon.redeemed) {
              console.log('??? filterIcoupons with couponCode: ' + coupon.couponCode);
              store.commit('deleteCouponByCode', coupon.couponCode);
              console.log('deleteCartItem 4');
              store.commit('deleteCartItem', coupon);
            }
            // }else if (coupon.uid){
            //     if (coupon.uid !== bootstrap.getBtaste() || coupon.redeemed) {
            //         console.log('??? filterIcoupons with couponCode: ' + coupon.couponCode);
            //         store.commit('deleteCouponByCode', coupon.couponCode);
            //         store.commit('deleteCartItem', coupon);
            //     }
            // }
          }
        }

        if (this.$ls.get('invitation')) {
          //remove Neukundenrabatt if still existing
          // for (let itm of store.getters.cartItems) {
          //     if ('couponCode' in itm && itm.couponCode === 'Neukundenrabatt') {
          //         store.commit('deleteCartItem', itm);
          //     }
          // }
          // for (let c of store.getters.coupons) {
          //     if (c.couponCode === 'Neukundenrabatt') {
          //         store.commit('deleteCouponByCode', c.couponCode);
          //     }
          // }
        }
        if (!noEvent) {
          ebus.$emit('couponsUpdated');
        }
      }
    },

    closeInfoDialog() {
      console.log('??? closeInfoDialog currentNext = ' + store.state.currentNext);
      this.infoDialog = false;

      let next = '' + store.state.currentNext;
      if (next.length > 0) {
        store.commit('currentNext', '');
        if (next === 'Coupons') {
          this.$ls.set('showAllCp', '1');
        }

        // if (next.indexOf('Bestellung') !== -1) {
        //     console.log('current next is ' + next);
        // } else {
        let query = '' + store.state.currentQuery;
        if (query.length > 0) {
          store.commit('currentQuery', '');
          console.log('goto query ' + query);
          this.$router.push({name: next, query: JSON.parse(query)});
        } else {
          this.$router.push({name: next});
        }

        // }
      }
    },


    // updateDrinksData(categories) {
    //     store.commit('drinkMenu', categories);
    //     ebus.$emit(qconst.notify$drinksUpdated);
    // },

    // lazyCreateStripeBuyer(email) {
    //     alert('lazyCreateStripeBuyer for email ' + email);
    //     let msg = {
    //         action: qconst.action$CreateStripeBuyer,
    // fuid: firebaseUtil.getFuid(),
    //         email: firebaseUtil.getEmail(),
    //         fuid: firebaseUtil.getFuid(),
    //     };
    //     if (email) {
    //         msg.email = email;
    //     }
    //     xhr.xhrSend(true, msg, (reply) => {
    //         if (reply.ok && reply.stripeCustomerId) {
    //             store.commit('stripeCustomerId', reply.stripeCustomerId);
    //             console.log('??? stripeCustomerId = ' + reply.stripeCustomerId);
    //         }
    //     }, (err) => {
    //         console.log('??? error creating stripe buyer: ' + err);
    //     });
    // },

    localStoreInvoiceAddress(ia) {
      let fd = this.$ls.get('formData') || {};
      fd.invoiceAddress = util.cloneMe(ia);
      util.sanitizeProps(fd.invoiceAddress);
      this.$ls.set('formData', fd);
    },

    localStoreDeliveryAddress(da) {
      let fd = this.$ls.get('formData') || {};
      fd.deliveryAddress = util.cloneMe(da);
      this.$ls.set('formData', fd);
    },


    // updateOpeningHours() {
    //     // store.commit('openingBegin', '');
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentDay = util.getDayOfWeek(rNow);
    //     // // console.log('currentDay = ' + currentDay);
    //     // if (currentDay === 1) {
    //     //     this.initNextThreeDays('1', '2', '3');
    //     // } else if (currentDay === 2) {
    //     //     this.initNextThreeDays('2', '3', '4');
    //     // } else if (currentDay === 3) {
    //     //     this.initNextThreeDays('3', '4', '5');
    //     // } else if (currentDay === 4) {
    //     //     this.initNextThreeDays('4', '5', '6');
    //     // } else if (currentDay === 5) {
    //     //     this.initNextThreeDays('5', '6', '7');
    //     // } else if (currentDay === 6) {
    //     //     this.initNextThreeDays('6', '7', '1');
    //     // } else {
    //     //     this.initNextThreeDays('7', '1', '2');
    //     // }
    //     //
    //     // //Init state for the user
    //     // let nextTakeAwayPeriod = {};
    //     // let closestTakeAwayPeriod = '';
    //     //
    //     // if (!store.getters.orderingEnabled) {
    //     // } else {
    //     //     if (store.state.day1.opened) {
    //     //         if (util.isWithinPeriod(store.state.day1.a, rNow)
    //     //             || util.isBeforePeriod(store.state.day1.a, rNow)) {
    //     //             nextTakeAwayPeriod = store.state.day1.a;
    //     //             closestTakeAwayPeriod = 'heute';
    //     //             // if (util.isBeforePeriod(store.state.day1.a, rNow)) {
    //     //             // store.commit('openingBegin', this.displayPeriodTime(store.state.day1.a));
    //     //             // }
    //     //         } else if (store.state.day1.b.fromHour !== store.state.day1.b.tillHour) {
    //     //             if (util.isWithinPeriod(store.state.day1.b, rNow)
    //     //                 || util.isBeforePeriod(store.state.day1.b, rNow)) {
    //     //                 nextTakeAwayPeriod = store.state.day1.b;
    //     //                 closestTakeAwayPeriod = 'heute';
    //     //                 // if (util.isBeforePeriod(store.state.day1.b, rNow)) {
    //     //                 // store.commit('openingBegin', this.displayPeriodTime(store.state.day1.b));
    //     //                 // }
    //     //             }
    //     //         }
    //     //     }
    //     //
    //     //     if (closestTakeAwayPeriod.length === 0 && store.state.day2.opened) {
    //     //         nextTakeAwayPeriod = store.state.day2.a;
    //     //         closestTakeAwayPeriod = 'morgen';
    //     //     }
    //     //
    //     //     if (closestTakeAwayPeriod.length === 0 && store.state.day3.opened) {
    //     //         nextTakeAwayPeriod = store.state.day3.a;
    //     //         closestTakeAwayPeriod = 'übermorgen';
    //     //     }
    //     // }
    //     // console.log('??? nextTakeAwayPeriod: ', nextTakeAwayPeriod);
    //     // console.log('??? closestTakeAwayPeriod: ', closestTakeAwayPeriod);
    //     //
    //     // // store.commit('nextTakeAwayPeriod', nextTakeAwayPeriod);
    //     // // store.commit('closestTakeAwayPeriod', closestTakeAwayPeriod);
    // },

    removeEmptyVariants(item) {
      try {
        if (item && item.extras && item.extras.variants) {
          let relevantVs = [];
          let stepIndex = 0;
          for (let v of item.extras.variants) {
            v.stepIndex = ++stepIndex;
            if (v.options && v.options.length > 0) {
              for (let option of v.options) {
                option.stepIndex = stepIndex;
              }
              relevantVs.push(v);
            }
          }
          item.extras.variants = relevantVs;
        }
      } catch (e) {
        console.log('error in removeEmptyVariants: ' + e.message);
      }
    },

    addMissingMenuItemProps(item, type) {
      if (!item || !type) {
        return;
      }

      item.search = util.noHtml(item.nameDE || '').toLowerCase()
        + ' ' + util.noHtml(item.descriptionDE || '').toLowerCase();
      item.type = type;
      if (!('buyable' in item)) {
        item.buyable = true;
      }
      if (!('withinOrderTimes' in item)) {
        item.withinOrderTimes = true;
      }
    },

    async updateFoodData(categories, forceUpdate) {
      for (let c of categories) {
        c.type = 'food';
        for (let i of c.items) {
          c.search = util.noHtml(c.categoryDE).toLowerCase();
          this.removeEmptyVariants(i);
          this.addMissingMenuItemProps(i, qconst.type$foodOrder);
          //         if(!i.streichPreis){
          //             i.streichPreis =
          //         }
        }
      }
      let display = categories;// this.filterMenuForDisplay(categories);

      let eq = display.length === store.getters.foodMenu.length;
      if (eq) {
        eq = util.mapEquals(display, util.cloneMe(store.getters.allFoodMenu));
      }
      store.commit('foodMenu', display);
      if (forceUpdate) {
        this.$ls.set('lastMenuUpdate', Date.now());
        console.log('lastMenuUpdate updated now');
      }
      if (eq && !forceUpdate) {
        console.log('foodMenu is equal');
        return categories.length > 0;
      } else {
        console.log('emit notify$foodsUpdated');
        ebus.$emit(qconst.notify$foodsUpdated, {force: true});
        return true;
      }
    },

    async updateDrinksData(categories, forceUpdate) {
      for (let c of categories) {
        c.type = 'drink';
        for (let i of c.items) {
          c.search = util.noHtml(c.categoryDE).toLowerCase();
          this.removeEmptyVariants(i);
          this.addMissingMenuItemProps(i, qconst.type$drinkOrder);
          //         if(!i.streichPreis){
          //             i.streichPreis =
          //         }
        }
      }
      let display = categories;// this.filterMenuForDisplay(categories);
      let eq = display.length === store.getters.drinkMenu.length;
      if (eq) {
        eq = util.mapEquals(display, util.cloneMe(store.getters.allDrinkMenu));
      }
      store.commit('drinkMenu', display);
      if (forceUpdate) {
        this.$ls.set('lastMenuUpdate', Date.now());
        console.log('lastMenuUpdate updated now');
      }
      if (eq && !forceUpdate) {
        console.log('drinkMenu is equal');
        return categories.length > 0;
      } else {
        console.log('emit notify$drinksUpdated');
        ebus.$emit(qconst.notify$drinksUpdated, {force: true});
        return true;
      }
    },

    // filterGlobalExtras(cats) {
    //   if (!cats) {
    //     return;
    //   }
    //
    //   console.log('filterGlobalExtras...');
    //
    //   //filter out inactive global extras
    //   let globalExtras = store.getters.appconfig.globalExtras;
    //   let inactiveExtras = [];
    //   if (globalExtras) {
    //
    //
    //     for (let e of globalExtras) {
    //       if (!e.active && e.label) {
    //         let l = util.withoutSplits(e.label.toLowerCase().trim());
    //         inactiveExtras.push(l);
    //       }
    //     }
    //
    //     console.log('Reduced globalExtras = ' + JSON.stringify(inactiveExtras));
    //   }
    //
    //   for (let cat of cats) {
    //     if (!cat.items) {
    //       continue;
    //     }
    //     for (let item of cat.items) {
    //       if (item.extras && item.extras.variants) {
    //         for (let step of item.extras.variants) {
    //           if (!step.options) {
    //             continue;
    //           }
    //           for (let i = 0; i < step.options.length; i++) {
    //             let option = step.options[i];
    //             let l = util.withoutSplits(option.labelDE.toLowerCase().trim());
    //             option.active = !inactiveExtras.includes(l);
    //             // console.log('option activ: ' + !!option.active + option.labelDE);
    //             // if (inactiveExtras.includes(option.labelDE.toLowerCase())) {
    //             //     itm.extras.variants.splice(i--, 1);
    //             // }
    //           }
    //         }
    //
    //
    //       }
    //     }
    //   }
    // },

    // filterMenuForDisplay(cats) {
    // let relevantCats = [];
    // try {
    //     //filter out menu by time
    //     let rNow = new Date();
    //     let currentHour = rNow.getHours();
    //     let currentMinutes = rNow.getMinutes();
    //
    //     let today = '' + util.getWeekdayAsNum();
    //     console.log('today = ' + today);
    //
    //     for (let cat of cats) {
    //
    //         // ***************************
    //         // Fix default values
    //         // ***************************
    //         if (cat.items) {
    //             for (let itm  of cat.items) {
    //                 if (typeof (itm.bestand) === 'undefined' || !store.state.enableBestand) {
    //                     itm.bestand = -1; // hasBestand = false
    //                 }
    //                 if (typeof (itm.lieferzeit) === 'undefined') {
    //                     itm.lieferzeit = '';
    //                 }
    //                 if (typeof (itm.num) !== 'undefined') {
    //                     itm.articleNo = itm.num;
    //                 }
    //             }
    //         }
    //
    //         // ***************************
    //         // Filter required for all use cases
    //         // ***************************
    //
    //         //filter out menu by days
    //         if (cat.days) {
    //             if (!cat.days.includes(today)) {
    //                 console.log('filter out missing cat day ' + cat.categoryDE);
    //                 continue;
    //             }
    //             console.log('cat day exists for ' + cat.categoryDE);
    //         }
    //         if (cat.orderTimes) {
    //             // orderTimes:{
    //             //     '1':{
    //             //         validFrom: ...
    //             //         validTo: ...
    //             //     },
    //             //     '4':{
    //             //         validFrom: ...
    //             //         validTo: ...
    //             //     }
    //             // }
    //             let times = cat.orderTimes[today];
    //             if (times) {
    //                 if (times.validFrom) {
    //                     try {
    //                         let fIdx = times.validFrom.indexOf(':');
    //                         let fromHour = parseInt(times.validFrom.substring(0, fIdx), 10);
    //                         let fromMinute = parseInt(times.validFrom.substring(fIdx + 1, 5), 10);
    //
    //                         if (currentHour < fromHour) {
    //                             console.log('filter out cat by orderTimes fromHour ' + cat.categoryDE);
    //                             continue;
    //                         }
    //
    //                         if (currentHour === fromHour) {
    //                             if (currentMinutes < fromMinute) {
    //                                 console.log('filter out cat by orderTimes fromMinute ' + cat.categoryDE);
    //                                 continue;
    //                             }
    //                         }
    //
    //                     } catch (e) {
    //                         console.log('Error in validFrom parsing: ' + e.message);
    //                     }
    //                 }
    //                 if (times.validTo) {
    //                     try {
    //                         let tIdx = times.validTo.indexOf(':');
    //                         let tillHour = parseInt(times.validTo.substring(0, tIdx), 10);
    //                         let tillMinute = parseInt(times.validTo.substring(tIdx + 1, 5), 10);
    //
    //                         if (currentHour > tillHour) {
    //                             console.log('filter out cat by orderTimes tillHour ' + cat.categoryDE);
    //                             continue;
    //                         }
    //
    //                         if (currentHour === tillHour) {
    //                             if (currentMinutes > tillMinute) {
    //                                 console.log('filter out cat by orderTimes tillMinute ' + cat.categoryDE);
    //                                 continue;
    //                             }
    //                         }
    //                     } catch (e) {
    //                         console.log('Error in validTo parsing: ' + e.message);
    //                     }
    //                 }
    //             }
    //         }
    //
    //         // ***************************
    //         // Filter required for inhouse only
    //         // ***************************
    //
    //         if (store.getters.inhouse) {
    //             if (cat.validFromHour) {
    //                 try {
    //                     let fIdx = cat.validFromHour.indexOf(':');
    //                     let fromHour = parseInt(cat.validFromHour.substring(0, fIdx), 10);
    //                     let fromMinute = parseInt(cat.validFromHour.substring(fIdx + 1, 5), 10);
    //
    //                     if (currentHour < fromHour) {
    //                         continue;
    //                     }
    //
    //                     if (currentHour === fromHour) {
    //                         if (currentMinutes < fromMinute) {
    //                             continue;
    //                         }
    //                     }
    //
    //                 } catch (e) {
    //                     console.log('Error in validFromHour parsing: ' + e.message);
    //                 }
    //             }
    //             if (cat.validTillHour) {
    //                 try {
    //                     let tIdx = cat.validTillHour.indexOf(':');
    //                     let tillHour = parseInt(cat.validTillHour.substring(0, tIdx), 10);
    //                     let tillMinute = parseInt(cat.validTillHour.substring(tIdx + 1, 5), 10);
    //
    //                     if (currentHour > tillHour) {
    //                         continue;
    //                     }
    //
    //                     if (currentHour === tillHour) {
    //                         if (currentMinutes > tillMinute) {
    //                             continue;
    //                         }
    //                     }
    //
    //                 } catch (e) {
    //                     console.log('Error in validTillHour parsing: ' + e.message);
    //                 }
    //             }
    //         }
    //
    //         relevantCats.push(cat);
    //     }//eof loop
    // } catch (outerE) {
    //     console.log('Error in filterMenuForDisplay: ' + outerE.message);
    // }
    //
    //
    // return relevantCats;
    // },

    async lazyPullMenus() {
      //prevent the method to execute twice
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadEaserGetLastModifiedValues');
      if (!easer || now - parseInt(easer) > 20 * 1000) {
        setGlobalKeyValue('loadEaserGetLastModifiedValues', now);
      } else {
        //eased
        return;
      }
      // let foodPulled = false;
      // let drinkPulled = false;
      //
      // let foodInStore = this.$ls.get('food');
      // let lfm = this.$ls.get('lastFoodMod', -1);
      // if (!foodInStore || lfm === -1) {
      //     foodPulled = true;
      //     console.log('force pullFoodMenu because foodInStore or lfm is empty');
      //     this.pullFoodMenu();
      // }
      //
      // let drinkInStore = this.$ls.get('drinks');
      // let dfm = this.$ls.get('lastDrinksMod', -1);
      // if (!drinkInStore || dfm === -1) {
      //     drinkPulled = true;
      //     console.log('force pullDrinkMenu because drinkInStore or dfm is empty');
      //     this.pullDrinkMenu();
      // }
      //
      // if (drinkPulled && foodPulled) {
      //     console.log('do not pull menus because drinkPulled && foodPulled');
      //     return;
      // }


      //get the latsModified value from the database
      let msg = {
        action: qconst.action$GetLastModifiedValues
      };
      await xhr.xhrSend(true, msg, (res) => {
        let future = Date.now();
        let lastModifiedFoodMenu = future;
        let lastModifiedDrinkMenu = future;
        if (res.ok) {
          if (res.lastModifiedFoodMenu) {
            lastModifiedFoodMenu = res.lastModifiedFoodMenu;
            console.log('pulled lastModifiedFoodMenu=' + lastModifiedFoodMenu);
          }
          if (res.lastModifiedDrinkMenu) {
            lastModifiedDrinkMenu = res.lastModifiedDrinkMenu;
            console.log('pulled lastModifiedDrinkMenu=' + lastModifiedDrinkMenu);
          }
        }

        let anyUpdate = false;
        if (lastModifiedFoodMenu > (this.$ls.get('lastFoodMod') || -1)) {
          console.log('pullFoodMenu again');
          anyUpdate = true;
          this.pullFoodMenu(lastModifiedFoodMenu);
        } else {
          console.log('no need to pullFoodMenu again; lastModifiedFoodMenu=' + lastModifiedFoodMenu + ' < lastFoodMod=' + (this.$ls.get('lastFoodMod') || -1));
        }
        if (lastModifiedDrinkMenu > (this.$ls.get('lastDrinksMod') || -1)) {
          console.log('pullDrinkMenu again');
          anyUpdate = true;
          this.pullDrinkMenu(lastModifiedDrinkMenu);
        } else {
          console.log('no need to pullDrinkMenu again; lastModifiedDrinkMenu=' + lastModifiedDrinkMenu + ' < lastDrinksMod=' + (this.$ls.get('lastDrinksMod') || -1));
        }
        if (!anyUpdate) {
          console.log('menu has not anyUpdate');
          this.$ls.set('lastMenuUpdate', Date.now());
          console.log('lastMenuUpdate updated now');
        }
      }, (err) => {
        console.log('Error in  lazyPullMenus');
      })

      // let lmfm = store.state.lastModifiedFoodMenu;
      // if (lmfm) {
      //     let lfm = this.$ls.get('lastFoodMod', -1);
      //     if (lfm < lmfm) {
      //         console.log('force pullFoodMenu');
      //         this.pullFoodMenu();
      //     } else {
      //         console.log('no need to pullFoodMenu');
      //     }
      // } else {
      //     this.pullFoodMenu();
      // }
    },

    async pullFoodMenu(lastModifiedFoodMenu) {
      let msg = {
        action: qconst.action$PullFoodMenu,
      };
      await xhr.xhrSend(true, msg, async (reply) => {
        if (reply.ok && reply.menudata) {
          console.log('pullFoodMenu was ok');
          let menu = reply.menudata;
          let fullMenu = appendCategoryNameToMenuItems(util.cloneMe(menu));
          let foodMenuData = this.filterMenu(menu);

          await setCachedKeyValue('food', fullMenu);
          // this.$ls.set('food', fullMenu);

          // console.log('loaded foodMenu: ', foodMenuData);

          if (!foodMenuData) {
            foodMenuData = [];
          }

          if (await this.updateFoodData(foodMenuData, true)) {
            this.$ls.set('lastFoodMod', lastModifiedFoodMenu);

            //evaluate all cartItems and remove all items which do not exist
            for (let itm of util.cloneMe(store.getters.cartItems)) {
              if (itm.couponCode || itm.type !== qconst.type$foodOrder) {
                continue;
              }
              let foodItem = store.getters.getFoodById(itm.id);
              if (!foodItem) {
                console.log('deleteCartItem 1');
                store.commit('deleteCartItem', itm);
              }
            }
          }
        } else {
          console.log('error: pullFoodMenu was notok');
        }
      }, (err) => {
        console.log('pullFoodMenu error: ' + err);
      }, 12 * 1000);
    },

    filterMenu(menu) {
      if (typeof menu === 'string') {
        menu = JSON.parse(menu);
      }
      let relevantCats = [];
      try {
        for (let cat of menu) {

          // //custom
          // if (cat.categoryDE.toLowerCase().startsWith('gutschein')) {
          //     continue
          // }

          let relevantItems = [];

          if (cat.items) {
            let _relevantItems = cat.items.filter((i) => {
              return true;

              // let iu = (typeof i.inhouseOnly === 'undefined');
              // let tu = (typeof i.takeawayOnly === 'undefined');
              // if (iu && tu) {
              //   return true;
              // }
              // if (!i.inhouseOnly && !i.takeawayOnly) {
              //   return true;
              // }
              // if (store.getters.inhouse) {
              //   return !iu && i.inhouseOnly;
              // } else {
              //   let x = !tu && i.takeawayOnly;
              //   // console.log('filter item ' + i.nameDE + ' = ' + x);
              //   return x;
              // }
            });
            for (let item of _relevantItems) {
              //note: the backend filters out item with missing posId automatically
              // if (qconst.withPosApi) {
              //   if (item.section || (item.posId && item.nameDE)) {
              relevantItems.push(item);
              //   } else {
              //     console.log('filter out item with missing posId: ' + item.nameDE);
              //   }
              // } else {
              //   relevantItems.push(item);
              // }
            }
          }

          if (relevantItems.length > 0) {

            //Filter out options with the word "pfand"
            if (store.getters.inhouse) {
              for (let itm of relevantItems) {
                if (itm.extras && itm.extras.variants) {
                  let v = itm.extras.variants;
                  let is = 0;
                  for (let step of v) {
                    if (step.options) {
                      let io = 0;
                      for (let opt of step.options) {
                        opt.active = true;
                        if (opt.labelDE.toLowerCase().includes('pfand')) {
                          step.options.splice(io--, 1);
                        }
                        ++io;
                      }
                      if (step.options.length === 0) {
                        itm.extras.variants.splice(is--, 1);
                      }
                      ++is;
                    }
                  }
                }

                if (typeof itm.substances === 'undefined') {
                  itm.substances = {};
                }
              }
            }

            let c = util.cloneMe(cat);
            c.items = relevantItems;
            relevantCats.push(c);
          }
        }

        // this.filterGlobalExtras(relevantCats);

      } catch (e) {
        console.log('Error in filterMenu');
      }

      return appendCategoryNameToMenuItems(relevantCats);
    },

    async pullDrinkMenu(lastModifiedDrinkMenu) {
      let msg = {
        action: qconst.action$PullDrinkMenu,
      };
      await xhr.xhrSend(true, msg, async (reply) => {
        if (reply.ok && reply.menudata) {
          console.log('pullDrinkMenu was ok');
          let menu = reply.menudata;
          let fullMenu = appendCategoryNameToMenuItems(util.cloneMe(menu));
          let drinkMenuData = this.filterMenu(menu);

          await setCachedKeyValue('drinks', fullMenu);
          // this.$ls.set('drinks', fullMenu);

          // console.log('loaded drinkMenu ', drinkMenuData);

          if (!drinkMenuData) {
            drinkMenuData = [];
          }

          if (await this.updateDrinksData(drinkMenuData, true)) {
            this.$ls.set('lastDrinksMod', lastModifiedDrinkMenu);

            //evaluate all cartItems and remove all items which do not exist
            for (let itm of util.cloneMe(store.getters.cartItems)) {
              if (itm.couponCode || itm.type !== qconst.type$drinkOrder) {
                continue;
              }
              let item = store.getters.getDrinkById(itm.id);
              if (!item) {
                console.log('deleteCartItem 2');
                store.commit('deleteCartItem', itm);
              }
            }
          }
        } else {
          console.log('error: pullDrinkMenu was notok');
        }
      }, (err) => {
        console.log('pullDrinkMenu error: ' + err);
      }, 12 * 1000);
    },

    //runs only once on initApp()
    // showScannedCouponWarning(notify) {
    //     setTimeout(() => {
    //         if (store.getters.scannedCode.length > 0) {
    //             let scannedCoupon = store.getters.getScannedCoupon;
    //             if (!scannedCoupon) {
    //                 //FIXME: die meldung erscheint, obwohl der 15% Gutschein im Warenorb ist
    //                 // if (notify) {
    //                 //     ebus.$emit('showInfo', {title: 'Der Gutschein "' + store.getters.scannedCode + '" wurde bereits eingelöst oder ist nicht mehr gültig.'});
    //                 // }
    //                 console.log('scannedCouponValid: false');
    //                 store.commit('scannedCouponValid', false);
    //             } else {
    //                 console.log('scannedCouponValid: true');
    //                 store.commit('scannedCouponValid', true);
    //             }
    //         }
    //     }, 18000);
    // },

    doRegisterBusListener() {
      //We need SSE for order state updates, and for group ordering
      if (sseEnabled) {
        console.log('Register sse listener');
        let outboundSource = baseURL + 'outbound/v/' + getBtaste() + '/service';
        sse.initSSE(outboundSource, (alreadyOpen) => {

          ebus.$emit('sse-eventbus.connected');

          if (alreadyOpen) {
            // openCallback();
            return;
          }

          // openCallback();
        }, () => {
          //SSE stream is now closed
          console.log('SSE stream is now closed');
          ebus.$emit('sse-eventbus.disconnected');
        }, (message) => {
          //Dispatch outbound actions
          console.log('<<< ==== SSE =====', message);
          if (message.outboundAction !== undefined) {
            if (message.outboundAction.startsWith('notify')) {
              ebus.$emit(message.outboundAction);
            } else {
              ebus.$emit('outboundAction', message);
            }
          }
        }, getBtaste());
      }
    },

    initSwMessages() {
      try {
        navigator.serviceWorker.addEventListener('message', event => {
          if (event.data && event.data.msg) {
            if (event.data.msg === 'swSelfDestroyed') {
              console.log('...received swSelfDestroyed');
              ebus.$emit('swWasDestroyed');
              swUnregisterHelper(navigator);
            }
          }
        });
      } catch (e) {

      }
    },

    deleteCacheStorage() {
      // CacheStorage delete
      // try {
      //     navigator.serviceWorker.getRegistration().then((reg) => {
      //         if (reg) {
      //             console.log('sw: sw found');
      //             this.clearSwInterval();
      //             reg.unregister();
      //             console.log('sw: sw was unregistered');
      //             caches.keys().then(cacheNames => {
      //                 cacheNames.forEach(cn => {
      //                     if (cn.startsWith(cacheName)) {
      //                         console.log('sw: cacheName found');
      //                         caches.delete(cn);
      //                         console.log('sw: cache was deleted');
      //                     }
      //                 });
      //             }).then(() => {
      //                 console.log('sw: would reload now');
      //             });
      //         } else {
      //             console.log('sw: NO sw found');
      //         }
      //     });
      // } catch (e) {
      //     console.log('sw: error in deleteCache: ', e);
      // }
    },

    clearSwInterval() {
      if (this.swUpdateInterval) {
        util.clearTheInterval(this.swUpdateInterval);
        this.swUpdateInterval = null;
      }
    },

    /**
     *
     * @param onFocus
     * @param cb true if the app is allowed to reload, false otherwise
     */
    async checkForSwUpdate(onFocus, cb) {
      if (store.getters.isKiosk) {
        return;
      }

      try {
        if (window.isoe) {
          triggerSwDestroy();
          return;
        }
      } catch (e) {

      }

      let now = Date.now();
      let easer = getGlobalValueOrZero('checkForSwUpdate');
      if (!easer || now - parseInt(easer) > 10 * 1000) {
        setGlobalKeyValue('checkForSwUpdate', now);
      } else {
        //eased
        return;
      }

      console.log('reload: checkForSwUpdate lastPwaUpdate...');

      if (store.getters.cartProtected) {
        console.log('reload: checkForSwUpdate cancelled because cart is protected');
        return;
      }

      // let lastPwaUpdate = this.$ls.get('lastPwaUpdate');

      if (!this.readyForNextPwaUpdateCheck()) {
        return;
      }

      //manually check for update by comapring the contents of the serviceWorkerFile
      await xhr.xhrGetFileContent('/service-worker.js', (fileContent) => {
        // console.log('reload  SW fileContent downloaded :::::: ');

        let currentVersion = appManager.getSwVersion();
        console.log('reload: current SW: ' + currentVersion);

        if (onFocus || !this.isCritical()) {
          appManager.setSwVersion(fileContent, (newVersion) => {
            //don't reload the very first time when currentVersion is null
            if (currentVersion && newVersion && currentVersion !== newVersion) {
              console.log('reload: SW version changed from ' + currentVersion + 'to ' + newVersion);
              this.lazyUpdatePwa();
              // alert('reload: SW version changed from ' + currentVersion + 'to ' + newVersion);
              //at this time shouldReload os still false => new content not cached yet
              //but the reload is required to trigger the SW update cicly of workbox
              // if (cb) {
              //     cb(false);
              // }
              // doReload();
            } else {
              console.log('reload: SW version unchanged');
              if (cb) {
                cb(true); //the app is older than 20 minutes
              }
            }
          });
        } else {
          if (cb) {
            cb(true);
          }
        }

        // console.log(fileContent);
      }, (err) => {
        console.log('there is no service worker on the server');
        // if (appManager.isStandalone()) {
        //   swDestroy();
        // }
        if (cb) {
          cb(true);
        }
      })

    },

    // reload(toSummary) {
    //   //only reload the app if there is an update or toSummary=true
    //   try {
    //     if (!toSummary && (appManager.hasLocalStorage() && !localStorage.getItem('shouldReload'))) {
    //       return;
    //     }
    //   } catch (e) {
    //   }
    //   // this.setLastPwaUpdate();
    //
    //   // this.$ls.remove('shouldReload');
    //   // alert('reload with shouldReload');
    //   doReload(toSummary);
    // },
    //
    // doReload(toSummary) {
    //   console.log('reload now...');
    //
    //   // this.setLastPwaUpdate();
    //   this.$ls.remove('shouldReload');
    //
    //   let query = '';
    //   let suff = '';
    //   if (toSummary) {
    //     suff = '#/Korb';
    //   } else {
    //     if (store.getters.scannedCode.length > 0 && store.getters.scannedCouponValid) {
    //       query = '?couponCode=' + store.getters.scannedCode;
    //     }
    //   }
    //   window.location = 'https://' + window.location.host + '/' + query + suff;
    // },

    showQuestion(question, text, yesLabel, noLabel, yesAction, cb, params) {
      this.currentQuestion = question;
      this.currentYesAction = yesAction;
      this.currentQtext = text;
      if (!yesLabel) {
        yesLabel = 'Ja';
      }
      this.currentQYesLabel = yesLabel;
      if (!noLabel) {
        noLabel = 'Nein';
      }
      this.currentQNoLabel = noLabel;
      this.questionDialog = true;
      this.biggerYesButton = params?.biggerYesButton;
      if (cb) {
        this.currentCallback = cb;
      } else {
        this.clearCallback();
      }
    },

    questionYes() {
      console.log('questionYes...');
      this.questionDialog = false;
      //user selected yes
      if (this.currentYesAction) {
        if (this.currentYesAction === 'forceReload') {
          doReload('forceReload in question');
          // this.reload(false);
        } else if (this.currentYesAction === 'switch2NewVersion') {
          // console.log('Post message SKIP_WAITING');
          // try {
          //     navigator.serviceWorker.controller.postMessage({
          //         type: 'SKIP_WAITING',
          //     });
          //     setTimeout(() => {
          this.$ls.remove('shouldReload');
          doReload('switch2NewVersion in question');
          // window.location.reload();
          //     }, 1000);
          // } catch (e) {
          //     console.log('Error sending post message SKIP_WAITING')
          // }
        }
          // else if (this.currentYesAction === 'requestPush') {
          // if (this.currentCallback) {
          //     ebus.$emit('' + this.currentCallback, 'yes');
          // }
          // firebaseUtil.requestPushToken(false);
        // }
        else if (this.currentYesAction === 'gotoSettings') {
          this.$router.push({name: 'Einstellungen'});
        }
        this.currentYesAction = '';
      }

      if (this.currentCallback) {
        let cbNames = this.currentCallback.split(' ');
        for (let cbName of cbNames) {
          setTimeout(() => {
            ebus.$emit('' + cbName, 'yes');
          }, 300);
        }
      }
      this.clearCallback();
    },
    clearCallback() {
      this.currentCallback = '';
    },
    questionNo() {
      console.log('questionNo...');
      this.questionDialog = false;

      if (this.currentYesAction) {
        // if (this.currentYesAction === 'requestPush') {
        // if (this.currentCallback) {
        //     ebus.$emit('' + this.currentCallback, 'no');
        // }
        // let rName = this.$route.name;
        // if (rName === 'Einstellungen') {
        //     ebus.$emit('disable-topic', '' + this.currentPushType)
        // }
        // }
        this.currentYesAction = '';
      }

      if (this.currentCallback) {
        let cbNames = this.currentCallback.split(' ');
        for (let cbName of cbNames) {
          setTimeout(() => {
            ebus.$emit('' + cbName, 'no');
          }, 300);
        }
      }
      this.clearCallback();
    },

    //helper
    containsFavId(items, id) {
      for (let item of items) {
        if (item.id === id) {
          return true;
        }
      }
      return false;
    },
    combineFavs() {
      // //combine favFoods from store and localStorage
      // let favFoods = [];
      // let favs = util.cloneMe(store.getters.favFoods);
      // let ph = require('@/assets/placeholder6-opti.png');
      //
      // for (let favFood of favs) {
      //     let foodItem = store.getters.getFoodById(favFood.id);
      //     if (!foodItem) {
      //         //ignore items that do not exist
      //         continue;
      //     }
      //     if ('image' in foodItem && foodItem.image.length > 0) {
      //         favFood.image = foodItem.image;
      //     } else {
      //         favFood.image = ph;
      //     }
      //     favFoods.push(favFood);
      // }
      // // if (favFoods.length === 0) {
      // let lsFavFoods = this.$ls.get('favFoods');
      // if (lsFavFoods) {
      //     let fv = JSON.parse(lsFavFoods);
      //     for (let v of fv) {
      //         //ignore items that already exist
      //         if (this.containsFavId(favFoods, v.id)) {
      //             continue
      //         }
      //
      //         let foodItem = store.getters.getFoodById(v.id);
      //         if (!foodItem) {
      //             //ignore items that do not exist
      //             continue;
      //         }
      //         if ('image' in foodItem && foodItem.image.length > 0) {
      //             v.image = foodItem.image;
      //         } else {
      //             v.image = ph;
      //         }
      //         favFoods.push(v);
      //     }
      // }
      // store.commit('replaceFavFoods', favFoods);
      // this.$ls.set('favFoods', favFoods);
      // ebus.$emit('favoritesUpdated');
    },


    //key = uid
    saveAppSettings() {
      let payload = util.cloneMe(this.$store.getters.appSettings);

      store.commit('appSettings', payload);

      //prevent the same app Settings to be saved twice
      let pString = JSON.stringify(payload);
      if (pString === this.lastAppSettingSaved) {
        console.log('lastAppSettingSaved already saved');
        return;
      }

      var msg = {
        action: qconst.action$SaveAppSettings,
        payload: payload,
        // uid: bootstrap.getBtaste()
        // restaurantId: restId,
        // appId: bootstrap.appId
        // favcartsApp:  util.cloneMe(store.state.userSettings.favcartsApp)
      };

      if (store.getters.selectedStore.filialnummer.length > 0) {
        msg.filialnummer = '' + store.getters.selectedStore.filialnummer;
      }
      //TODO add more filialnummern to pushTopicsListM note that the backend handles sets of subList and unsubList automatically

      console.log('going to save appSettings: ' + JSON.stringify(payload));

      //Send
      let _this = this;
      xhr.xhrSend(true, msg, (response) => {
        // ebus.$emit('info', 'Einstellungen erfolgreich gespeichert');
        console.log('appSettings saved', payload);
        _this.lastAppSettingSaved = pString;
      }, (err) => {
        console.log('??? Error saving appSettings: ' + err);
      });
    },

    // openFacebook() {
    //     let win = window.open('https://www.facebook.com/kerstin.mencz', '_blank');
    //     win.focus();
    // },
    //
    // openInsta() {
    //     let win = window.open('https://www.instagram.com/kikijaly/', '_blank');
    //     win.focus();
    // }

    startKeepAwake() {
      if (store.state.enableSelfServiceExtras) {
        console.log('startKeepAwake...');
        setUpWakelock();
        startVideo();
      }
    },
    stopKeepAwake() {
      if (store.state.enableSelfServiceExtras) {
        console.log('stopKeepAwake...');
        releaseWakelock();
        stopVideo();
      }
    },
  }
};
</script>
<style lang="scss">
@import './styles/layout';
@import './styles/base';
@import './styles/globalstyle';
@import './styles/custom';

:root {
  --ffamily: 'Poppins-Bold', sans-serif;
}

.demoWartermark {
  position: fixed;
  height: var(--layout-height);
  width: var(--layout-width);
  top: 0;
  //background-color: red;
  color: #222222;
  font-size: 100px;
  overflow: hidden;
  opacity: 0.08;
  z-index: 3000;
  pointer-events: none;
  text-align: center;
  padding-top: 40vh;
}

.screensaver {
  position: fixed;
  z-index: 3100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(black, 0.9);
}

.dialog-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
  transition: transform .2s ease-in-out;
}


/*.debugYoffset {*/
/*    position: fixed;*/
/*    top: 0;*/
/*    left: 0;*/
/*    z-index: 9999;*/
/*    width: var(--layout-width);*/
/*    min-height: 2px;*/
/*    background-color: red;*/
/*}*/

/** {*/
/*    -webkit-transform: none !important;*/
/*    -moz-transform: none !important;*/
/*    -ms-transform: none !important;*/
/*    -o-transform: none !important;*/
/*    transform: none !important;*/
/*}*/


//body .theme--light.v-application {
//background-color: rgba($accent, 0.1);
//background: radial-gradient(circle at 70%, #ffffff, $accent 80%, $accent 75%, #333 75%);
//background: radial-gradient(ellipse at left, rgba($accent, 0.3), transparent);
/*backdrop-filter: blur(4px);*/
//}


/*vuetify overwrites*/
.v-stepper__label {
  line-height: inherit;
}

.isKiosk {
  div.v-application.theme--light {
    font-size: var(--kiosk-font-size) !important;
  }
}

.theme--light.v-btn--active::before {
  opacity: 0;
}

/*.v-input {*/
/*    .v-input__slot {*/
/*        background-color: white;*/
/*    }*/
/*}*/
//.v-text-field--outlined fieldset {
//  border-color: currentColor !important
//}

//.v-stepper__wrapper {
//  overflow-x: visible !important;
//}

.v-list-item__content > * {
  line-height: inherit;
}

.v-time-picker-clock__item {
  cursor: pointer;
}

.pwa {
  .v-textarea textarea {
    line-height: 1.1rem;
  }

  .v-text-field {
    margin-bottom: 15px;
  }

  .v-text-field {
    padding-top: 0;
    margin-top: 0;
  }

  .v-text-field--outlined {
    border-radius: $box-border-radius;
  }
}

.v-input.v-text-field--outlined {
  border-radius: $box-border-radius;
}

.v-text-field--outlined > .v-input__control > .v-input__slot {
  background-color: white;
}

.app {
  //width: var(--layout-width);
  //height: var(--layout-height);
  overflow-x: hidden;

  .vvd-radio, .vvd-transparent {
    > .v-input__control > .v-input__slot {
      background-color: transparent;
    }
  }
}

/*.pwa .v-text-field--outlined fieldset {*/
/*    border: none;*/
/*}*/

.v-badge__badge {
  pointer-events: none;
}

.v-autocomplete__content .v-list-item__title {
  font-size: 1.4rem !important;
}

.v-ripple__container {
  display: none !important;
}

.v-dialog {
  /*    overflow-y: visible;*/
  overflow-x: hidden;

  .v-card__title {
    word-break: break-word;
  }
}


//Design
button.v-btn {
  box-shadow: none !important;
}

div.v-application {

  line-height: 1.4;

  &.theme--light {
    background-color: transparent;
    //background: radial-gradient(circle at 70%, #ffffff, $accent 80%, $accent 75%, #333 75%);
    background-repeat: no-repeat;
    background-size: cover;
    font-family: var(--ffamilyBody);
    font-weight: $fontWeight;
    font-size: $fontSize;
    color: $font-color;
  }

  .headline { //note pwa .headline does not work vor dialogs
    font-family: var(--ffamily) !important;
    //font-weight: 700;
    /*letter-spacing: 0.075em;*/
  }

  .v-select__selection {
    line-height: 1.3em;
  }

  .v-input input {
    max-height: initial;
  }

  i.v-icon.myAccent {
    color: $accent;
  }

  i.v-icon.myBrand {
    color: $brand;
  }

  i.v-icon.myPrime {
    color: $color-primary;
  }

  i.v-icon.myBlack {
    color: black;
  }

  i.v-icon.myGray {
    color: #999;
  }

  i.v-icon.myWhite {
    color: white;
  }

  /*.v-badge__badge.myRed*/

  .v-badge--dot .v-badge__badge {
    width: 12px;
    height: 12px;
  }

  .v-application--wrap {
    .v-snack__wrapper {
      background-color: black; //$accent;
      color: white;
    }
  }

  .v-snack--top {
    top: 80px;
  }

  /*.pwa .headline {*/
  /*    font-family: var(--ffamily) !important;*/
  /*}*/


  /*&.v-icon {*/
  /*    color: rgba(0, 0, 0, 0.3);*/
  /*}*/
}

.accentColor {
  color: $accent;
}

.textFont {
  font-family: var(--ffamilyBody);
  font-weight: $fontWeight;
}

.titleFont {
  font-family: var(--ffamily);
}

/*.schmuckschrift {*/
/*    font-family: var(--ffamilySchmuck);*/
/*    font-weight: normal;*/
/*}*/

.fontColor {
  color: $font-color;
}

.darkColor {
  -webkit-text-fill-color: $almostBlack;
  color: $almostBlack;
}

.headColor {
  color: $heading-color;
}


.secondaryFontColor {
  color: rgba($font-color, 0.7);
}

.fontWeight {
  font-weight: $fontWeight;
}

/*//only for iframe*/
/*.v-dialog--active {*/
/*    position: fixed;*/
/*    top: 0;*/
/*}*/

//bugfix https://github.com/vuetifyjs/vuetify/issues/4384
.v-overlay {
  touch-action: auto;
}

.v-overlay--active {
  .v-overlay__scrim {
    opacity: 0.98 !important;
  }
}


/*.v-overlay--active .v-overlay__scrim {*/
/*    opacity: 0.85 !important;*/
/*}*/

.selected {
  .v-icon {
    color: $color-primary;
  }
}

.v-card__subtitle, .v-card__text {
  font-size: inherit;
  letter-spacing: inherit;
  /*font-weight: 300;*/
}

/*.v-application .v-badge__badge.myRed {*/
/*    background-color: black; //#E7474C;*/
/*    //font-weight: 700;*/
/*    padding: 3px 0 0 0;*/
/*    font-size: 0.80em;*/
/*    font-family: sans-serif;*/
/*}*/


/*.v-application .v-list-item__title .v-badge__badge.myRed {*/
/*    padding-top: 1px;*/
/*}*/


////////////////////////////////////////////////////
html, body {
  font-size: $fontSize;
  //only for  iframe
  /*background-color: transparent;*/

  /*background-color: white;*/
}

body {
  line-height: 26.1333px;
  /*letter-spacing: 0.05em;*/
  font-family: var(--ffamilyBody);
  /*font-weight: 400;*/
  text-rendering: optimizeLegibility;
  font-variant-numeric: lining-nums tabular-nums;

  max-width: var(--layout-width);
  /*overflow-x: hidden;*/
}

$headingScaleFactor: 1.0;
h1 {
  font-size: 2rem * $headingScaleFactor;
}

h2 {
  font-size: 1.5rem * $headingScaleFactor;
}

h3 {
  font-size: 1.17rem * $headingScaleFactor;
}

h4 {
  font-size: 1rem * $headingScaleFactor;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--ffamily);
  font-weight: 600;
  color: $heading-color;
  font-style: normal;
  /*//font-weight: 700;*/
  /*letter-spacing: 0.075em;*/
  text-transform: none;
  word-break: break-word;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

table {
  border-collapse: collapse;
}

.aoverlay {
  i.v-icon {
    font-size: 100px !important;
  }
}

////////////////
#background_wrap {
  //z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  color: #dddddd;
  background-position: 50% 50%;
  background-image: url('./assets/bg.jpg');
  background-color: $appBgColor;
  /*background-attachment: fixed;*/
}

.pwa {
  z-index: 2;
  background-color: transparent;
  /*nice bacground gradient*/
  //background: radial-gradient(ellipse at left, rgba($accent, 0.3), transparent);
}

//only for iframes
/*.device-xs {*/
/*    .container {*/
/*        padding-left: 0;*/
/*        padding-right: 0;*/
/*    }*/
/*}*/

.vdevice-xs {
  /*.afooter .b {*/
  /*    padding-bottom: 56px; //height of bottom-nav*/
  /*}*/

  .v-application {
    &.theme--light {
      font-size: $fontSize -1; // smaller than $fontSize
    }
  }

  #scrollDown {
    bottom: 65px;
    right: 10px;
  }
}

.cardGradient {
  background: rgb(11, 65, 81);
  background: linear-gradient(350deg, rgba(11, 65, 81, 0.98) 0%, rgba(36, 159, 156, 0.85) 100%);
}


///////////////////////////////

/*.v-application .afooter a {*/
/*    color: white;*/
/*}*/

/*<!--.afooter {-->*/
/*<!--    !*margin-top: 70px;*!-->*/
/*<!--    !*background-image: url(data:image/png;base64,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);*!-->*/
/*<!--    !*background-position: center;*!-->*/
/*<!--    !*background-repeat: repeat;*!-->*/
/*<!--    !*background-size: cover;*!-->*/
/*<!--    z-index: 2;-->*/
/*<!--    position: relative;-->*/

/*<!--    !*.paymentMethods {*!-->*/
/*<!--    !*    img {*!-->*/
/*<!--    !*        height: 45px;*!-->*/
/*<!--    !*        width: auto;*!-->*/
/*<!--    !*        margin: 4px;*!-->*/
/*<!--    !*        display: inline-block;*!-->*/
/*<!--    !*    }*!-->*/
/*<!--    !*}*!-->*/

/*<!--    .pSign {-->*/
/*<!--        height: 45px;-->*/
/*<!--        width: auto;-->*/
/*<!--        margin: 4px;-->*/
/*<!--        display: inline-block;-->*/
/*<!--    }-->*/

/*<!--    .hIpacity {-->*/
/*<!--        opacity: 0.6;-->*/
/*<!--    }-->*/

/*<!--    .a {-->*/
/*<!--        padding: 40px 0;-->*/
/*<!--        color: white;-->*/
/*<!--        background-color: $color-primary-->*/
/*<!--    }-->*/

/*<!--    .b {-->*/
/*<!--        background-color: black;-->*/
/*<!--        //background-color: #111;-->*/
/*<!--        !*color: black !important;*!-->*/
/*<!--        font-size: 0.95em;-->*/

/*<!--        a {-->*/
/*<!--            !*margin: 0 1% 1.5%;*!-->*/
/*<!--        }-->*/

/*<!--        i {-->*/
/*<!--            margin: 0 2%;-->*/
/*<!--        }-->*/


/*<!--    }-->*/

/*<!--    img {-->*/
/*<!--        width: 75%;-->*/
/*<!--        height: auto;-->*/
/*<!--    }-->*/

/*<!--    h4 {-->*/
/*<!--        text-transform: uppercase;-->*/
/*<!--    }-->*/
/*<!--}-->*/

///////////////////////////////
/*<!--#scrollDown {-->*/
/*<!--    background-color: $color-primary;-->*/
/*<!--    position: fixed;-->*/
/*<!--    bottom: 15px;-->*/
/*<!--    right: 15px;-->*/
/*<!--    z-index: 44;-->*/
/*<!--    border-radius: $box-border-radius;-->*/
/*<!--    cursor: pointer;-->*/
/*<!--    padding: 0.6vw;-->*/
/*<!--}-->*/


/////////////////
.pwa-overly {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  /*background-color: rgba(yellow,0.5);*/
  background-color: transparent;
  pointer-events: all;
}

/////////////////////////////

.contactTable {
  td {
    padding: 5px 15px 5px 0;
  }
}

/////////////////////////////

/*.version {*/
/*    pointer-events: none;*/
/*    position: fixed;*/
/*    z-index: 101;*/
/*    right: 2px;*/
/*    bottom: 2px;*/
/*    color: rgba(blue, 0.8);*/
/*    font-size: 16px;*/
/*}*/


/*Only for iframe*/
/*.addedOverlay {
        z-index: 104;
        background-color: rgba($color-secondary, 0.8);
        position: fixed;
        top: 0;
        left: 0;
    }
    .aoverlay {
        position: fixed;
        left: 0;

        i.v-icon {
            font-size: 100px !important;
        }
    }*/

</style>

